<template>
    <div style="width: 99%; display: block; padding: 5px; margin-left: auto; margin-right: auto;">

        <div v-if="items_being_loaded == true">
            <loading
                :active="true"
                :can-cancel="false"
                :is-full-page="true">
            </loading>
        </div>

        <div v-else>
            <!-- Mobile filter toggle -->
            <div
              v-if="isMobile"
              class="d-flex justify-content-between align-items-center mb-2 px-1"
            >
              <b-button
                size="sm"
                variant="outline-primary"
                @click="filtersVisible = !filtersVisible"
              >
                <b-icon-funnel-fill class="mr-1"></b-icon-funnel-fill>
                {{ filtersVisible ? 'Hide Filters' : 'Show Filters' }}
              </b-button>
            </div>

            <!-- Filters -->
            <b-collapse :visible="!isMobile || filtersVisible" class="mb-2">
              <b-card style="background: #f2f2f2; margin-bottom: 10px;">
                <b-card-text>
                  <div style="display: flex; flex-wrap: wrap; gap: 10px;">
                    <div style="width: 200px;">
                      <div>FILTER VENDOR</div>
                      <b-form-select
                        :options="filteredVendors"
                        v-model="vendor_id"
                        @change="onVendorChange"
                      ></b-form-select>
                    </div>

                    <div style="width: 300px;">
                      <div>SEARCH</div>
                      <b-form-input
                        placeholder="SKU or INVOICE or CUSTOMER"
                        v-model="search_keyword"
                      ></b-form-input>
                    </div>

                    <div style="width: 200px;">
                      <div>ORDER TYPE</div>
                      <b-form-select
                        :options="order_type_options"
                        v-model="order_type_filter"
                        placeholder="Select order type"
                      ></b-form-select>
                    </div>

                    <div style="width: 250px;">
                      <div>ORDERING LOCATION</div>
                      <b-form-select
                        :options="ordering_location_options"
                        v-model="ordering_location"
                        @change="onOrderingLocationChange"
                        placeholder="Select ordering location"
                      ></b-form-select>
                    </div>

                    <div style="width: 250px;">
                      <div>VENDOR ORDER STATUS</div>
                      <b-form-select
                        :options="vendor_order_status_filter_options"
                        v-model="vendor_order_status_filter"
                        placeholder="Select status"
                      ></b-form-select>
                    </div>

                    <div style="width: 200px;">
                      <div>PO STATUS</div>
                      <b-form-select
                        :options="po_status_options"
                        v-model="po_status_filter"
                        placeholder="Show items"
                      ></b-form-select>
                    </div>

                    <div style="width: 200px;">
                      <div>MERCHANDISE STATUS</div>
                      <b-form-select
                        :options="merchandise_status_options"
                        v-model="merchandise_status_filter"
                        placeholder="Filter by status"
                      ></b-form-select>
                    </div>
                  </div>
                </b-card-text>
              </b-card>
            </b-collapse>

            <!-- Create Vendor PO Button -->
            <div v-if="showCreateVendorPOButton" style="margin-bottom: 15px;">
                <b-button variant="primary" @click="showCreateVendorPOModal">
                    Create Vendor Purchase Order ({{ selectedItems.length }} items selected)
                </b-button>
            </div>

            <div v-if="filtered.length == 0">
                <b-alert show variant="warning">NO CUSTOMER ORDERS</b-alert>
            </div>
            <div v-else class="diver">
                <table>
                    <thead>
                        <tr>
                            <th class="srr" style="width: 100px; background-color: lightyellow;">
                                <input
                                    type="checkbox"
                                    v-model="selectAll"
                                    @change="toggleSelectAll"
                                    :disabled="!selectedVendor"
                                >
                            </th>
                            <th class="srr" style="width: 100px; background-color: lightyellow;">SOLD DATE</th>
                            <th class="srr" style="width: 120px; background-color: lightyellow;">VENDOR</th>
                            <th class="srr" style="width: 130px; background-color: lightyellow;">PRODUCT SKU</th>
                            <th class="srr" style="width: 200px; background-color: lightyellow;">PRODUCT NAME</th>
                            <th class="srr" style="width: 80px; background-color: lightyellow;">QTY</th>
                            <th class="srr" style="width: 100px; background-color: lightblue;">SOLD PRICE</th>
                            <th class="srr" style="width: 120px; background-color: lightblue;">LANDED PRICE</th>
                            <th class="srr" style="width: 120px; background-color: lightblue;">REQUEST DATE</th>
                            <th class="srr" style="width: 150px; background-color: lightblue;">INVOICE No</th>
                            <th class="srr" style="width: 150px; background-color: lightblue;">CUSTOMER NAME</th>
                            <th class="srr" style="width: 250px; background-color: lightblue;">ORDERING LOC</th>
                            <th class="srr" style="width: 150px; background-color: lightblue;">ORDER TYPE</th>
                            <th class="srr" style="width: 130px; background-color: lightblue;">MERCHANDISE STATUS</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="item,idx in filtered" v-bind:key="idx">
                            <td class="srrv" style="text-align: center;">
                                <input
                                    type="checkbox"
                                    v-model="selectedItems"
                                    :value="item"
                                    :disabled="!selectedVendor || item.vendor_id !== selectedVendor.value || item.is_in_po"
                                >
                                <span v-if="item.is_in_po" style="color: #dc3545; font-size: 0.8rem;">
                                    (In PO #{{ item.existing_po_id }})
                                </span>
                            </td>
                            <td class="srrv">{{ formatDate(item.sold_at) }}</td>
                            <td class="srrv">{{item.vendor}}</td>
                            <td class="srrv" style="background: lightyellow;">
                                <span style="color: black; padding: 5px;">
                                    {{ item.updated_sku || item.product_sku }}
                                </span>
                            </td>
                            <td class="srrv">{{item.product_name}}</td>
                            <td class="srrv">{{item.quantity}}</td>
                            <td class="srrv" :class="getProfitClass(item)">
                                {{ parseFloat(item.selling_price).toFixed(2) }}
                            </td>
                            <td class="srrv">
                                {{ item.landed_cost }}
                            </td>
                            <td class="srrv">
                                <span v-if="item.edit && user_is_admin">
                                    <date-picker
                                        v-model="item.eta"
                                        format="MM-DD-YYYY"
                                        valueType="format"
                                        style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 130px; background: lightyellow;"
                                    ></date-picker>
                                </span>
                                <span v-else>
                                    {{formatDate(item.eta)}}
                                </span>
                            </td>
                            <td class="srrv" style="background: lightblue; font-weight: bold;">
                                <router-link :to="`/sales/viewsale/${item.invoice_id}`" class="invoice-link">
                                    <span style="color: black; padding: 5px;">{{item.invoice_id}}</span>
                                </router-link>
                            </td>
                            <td class="srrv">{{item.customer_name}}</td>
                            <td class="srrv">
                                <span v-if="item.ordering_locsub">
                                    {{packet.locsubsdict[item.ordering_locsub]}}
                                </span>
                            </td>
                            <td class="srrv">{{item.order_type.toUpperCase().replace('_', ' ')}}</td>
                            <td class="srrv">
                                <span v-if="item.merchandise_status == 2" class="badge badge-warning">
                                    BACKORDER
                                </span>
                                <span v-else-if="item.merchandise_status == 3" class="badge badge-info">
                                    SPECIAL ORDER
                                </span>
                                <span v-else class="badge badge-secondary">
                                    NORMAL
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Create Vendor PO Modal -->
            <b-modal id="create-vendor-po-modal" title="Create Vendor Purchase Order" size="xl" @hidden="resetVendorPOForm" hide-footer>
                <b-form @submit.prevent="createVendorPO">
                    <!-- PO Details -->
                    <div class="row mb-3">
                        <div class="col-md-6">
                            <b-form-group label="PO #" label-for="po-number" :state="!!vendorPOForm.poNumber">
                                <b-form-input
                                    id="po-number"
                                    v-model="vendorPOForm.poNumber"
                                    required
                                    placeholder="Enter PO number"
                                    :state="!!vendorPOForm.poNumber"
                                ></b-form-input>
                                <b-form-invalid-feedback>PO Number is required</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                        <div class="col-md-6">
                            <b-form-group label="BILL TO" label-for="billing-location" :state="!!vendorPOForm.billing_location">
                                <b-form-select
                                    id="billing-location"
                                    v-model="vendorPOForm.billing_location"
                                    :options="billing_location_options"
                                    required
                                    @change="handleBillingLocationChange"
                                    :state="!!vendorPOForm.billing_location"
                                ></b-form-select>
                                <b-form-invalid-feedback>Billing Location is required</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-6">
                            <b-form-group label="SHIP TO" label-for="shipping-location" :state="!!vendorPOForm.shipping_location">
                                <b-form-select
                                    id="shipping-location"
                                    v-model="vendorPOForm.shipping_location"
                                    :options="shipping_location_options"
                                    required
                                    @change="onshippingLocationChange"
                                    :state="!!vendorPOForm.shipping_location"
                                ></b-form-select>
                                <b-form-invalid-feedback>Shipping Location is required</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                        <div class="col-md-6">
                            <b-form-group label="RECEIVING LOCATION" label-for="receiving-location" :state="!!vendorPOForm.receivingLocation">
                                <b-form-select
                                    id="receiving-location"
                                    v-model="vendorPOForm.receivingLocation"
                                    :options="filteredReceivingLocations()"
                                    required
                                    :state="!!vendorPOForm.receivingLocation"
                                ></b-form-select>
                                <b-form-invalid-feedback>Receiving Location is required</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-6">
                            <b-form-group label="REQUEST ETA" label-for="eta">
                                <date-picker
                                    id="eta"
                                    v-model="vendorPOForm.eta"
                                    format="MM-DD-YYYY"
                                    valueType="format"
                                    style="width: 100%;"
                                ></date-picker>
                            </b-form-group>
                        </div>
                        <div class="col-md-6">
                            <b-form-group label="STATUS" label-for="status">
                                <b-form-select
                                    id="status"
                                    v-model="vendorPOForm.status"
                                    :options="vendor_order_statuses"
                                    required
                                ></b-form-select>
                            </b-form-group>
                        </div>
                    </div>

                    <hr>

                    <!-- Missing Products Section -->
                    <div v-if="missingProducts.length > 0" class="mb-3">
                        <h6 class="text-danger">
                            <b-icon-exclamation-triangle-fill></b-icon-exclamation-triangle-fill>
                            Products Not Found in System ({{ missingProducts.length }})
                        </h6>
                        <p class="text-muted small">These products don't exist in the product table. Fill in the details below to create them with full features.</p>
                        
                        <div v-for="(missing, index) in missingProducts" :key="index" class="missing-product-card p-3 mb-3 border rounded">
                            <!-- Product Header -->
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <div>
                                    <b-badge variant="secondary">Invoice: {{ missing.invoice_id }}</b-badge>
                                    <b-badge variant="info" class="ml-2">Original SKU: {{ missing.original_sku }}</b-badge>
                                    <b-badge v-if="missing.originalItem && missing.originalItem.merchandise_status == 2" variant="warning" class="ml-2">
                                        BACKORDER
                                    </b-badge>
                                    <b-badge v-else-if="missing.originalItem && missing.originalItem.merchandise_status == 3" variant="info" class="ml-2">
                                        SPECIAL ORDER
                                    </b-badge>
                                </div>
                                <div v-if="missing.saved" class="text-success">
                                    <b-icon-check-circle></b-icon-check-circle> Product Created
                                </div>
                            </div>

                            <!-- Image Upload -->
                            <div class="product-image-section mb-3">
                                <div class="d-flex align-items-start">
                                    <div class="product-image-preview mr-3" style="width: 100px; height: 100px;">
                                        <div v-if="missing.image_url" class="position-relative">
                                            <img :src="missing.image_url" 
                                                class="img-thumbnail" 
                                                style="width: 100px; height: 100px; object-fit: cover; cursor: pointer;"
                                                @click="openImagePreview(missing.image_url)">
                                            <b-button 
                                                size="sm" 
                                                variant="danger" 
                                                class="position-absolute top-0 right-0"
                                                style="top: -8px; right: -8px; border-radius: 50%; padding: 2px 6px;"
                                                @click.stop="missing.image_url = null; missing.image_file = null;">
                                                <b-icon-x font-scale="0.8"></b-icon-x>
                                            </b-button>
                                        </div>
                                        <div v-else class="image-placeholder border rounded d-flex align-items-center justify-content-center"
                                            style="width: 100px; height: 100px; background: #f8f9fa; cursor: pointer;"
                                            @click="uploadMissingProductImage(index)">
                                            <b-icon-image font-scale="2" class="text-muted"></b-icon-image>
                                        </div>
                                    </div>
                                    <div class="image-upload-buttons">
                                        <b-button 
                                            variant="outline-primary" 
                                            size="sm"
                                            @click="uploadMissingProductImage(index)"
                                            :disabled="missing.saving || missing.saved"
                                            class="mb-2">
                                            <b-spinner v-if="missing.uploading" small></b-spinner>
                                            <b-icon-cloud-upload v-else></b-icon-cloud-upload>
                                            {{ missing.uploading ? 'Uploading...' : 'Upload Image' }}
                                        </b-button>
                                        <small class="text-muted d-block">Upload product image</small>
                                    </div>
                                </div>
                            </div>

                            <!-- Barcode Scanner -->
                            <div class="barcode-scanner-section mb-3 p-2 border rounded">
                                <div class="d-flex align-items-center">
                                    <b-icon-upc-scan class="mr-2" font-scale="1.5"></b-icon-upc-scan>
                                    <h6 class="mb-0">Scan Barcode</h6>
                                </div>
                                <div class="mt-2">
                                    <b-input-group size="sm">
                                        <b-form-input
                                            v-model="missing.scannedBarcode"
                                            placeholder="Scan or type barcode..."
                                            @keyup.enter="lookupBarcodeForMissingProduct(index)"
                                            :disabled="missing.saved"
                                        ></b-form-input>
                                        <b-input-group-append>
                                            <b-button 
                                                variant="primary" 
                                                @click="lookupBarcodeForMissingProduct(index)"
                                                :disabled="missing.saved || !missing.scannedBarcode"
                                            >
                                                <b-icon-search></b-icon-search> Lookup
                                            </b-button>
                                            <b-button 
                                                variant="success" 
                                                @click="openScannerForMissingProduct(index)"
                                                :disabled="missing.saved"
                                                title="Use camera to scan barcode"
                                            >
                                                <b-icon-camera></b-icon-camera>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <small class="text-muted">Scan a barcode to auto-fill SKU and product details</small>
                                </div>
                            </div>

                            <!-- Basic Product Fields with Auto-Generate Buttons -->
                            <div class="row">
                                 <div class="col-md-3 mb-2">
                                    <b-form-group label="Collection Name" label-for="missing-collection">
                                        <b-form-input
                                            :id="'missing-collection-' + index"
                                            v-model="missing.collection_name"
                                            placeholder="Enter collection name"
                                            :readonly="missing.saved"
                                            @input="generateSkuAndDescription(index)"
                                        ></b-form-input>
                                        <small class="text-muted">Used in product name & description</small>
                                    </b-form-group>
                                </div>
                                <div class="col-md-3 mb-2">
                                    <b-form-group label="New SKU" label-for="new-sku" :state="!!missing.new_sku">
                                        <div class="d-flex">
                                            <b-form-input
                                                :id="'new-sku-' + index"
                                                v-model="missing.new_sku"
                                                placeholder="Auto-generated from attributes"
                                                required
                                                :readonly="missing.saved"
                                                :state="!!missing.new_sku"
                                                class="flex-grow-1"
                                            ></b-form-input>
                                            <b-button 
                                                size="sm" 
                                                variant="outline-primary" 
                                                @click="generateSkuAndDescription(index)"
                                                :disabled="missing.saved || !missing.category_id"
                                                class="ml-1"
                                                title="Auto-generate SKU, Name and Description">
                                                <b-icon-arrow-repeat></b-icon-arrow-repeat>
                                            </b-button>
                                        </div>
                                        <b-form-invalid-feedback>SKU is required</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-3 mb-2">
                                    <b-form-group label="Product Name" label-for="missing-name" :state="!!missing.product_name">
                                        <b-form-input
                                            :id="'missing-name-' + index"
                                            v-model="missing.product_name"
                                            placeholder="Auto-generated from attributes"
                                            required
                                            :readonly="missing.saved"
                                            :state="!!missing.product_name"
                                            @input="generateSkuAndDescription(index)"
                                        ></b-form-input>
                                        <b-form-invalid-feedback>Product name is required</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-3 mb-2">
                                    <b-form-group label="Category" label-for="missing-category">
                                        <b-form-select
                                            :id="'missing-category-' + index"
                                            v-model="missing.category_id"
                                            :options="categoryOptions"
                                            @change="loadMissingProductCategoryAttributes(index)"
                                            :disabled="missing.saved"
                                        >
                                            <option :value="null">Select Category</option>
                                        </b-form-select>
                                    </b-form-group>
                                </div>
                           
                            </div>

                            <!-- Collection Name and Subcategory -->
                            <div class="row">

                             
                           
                                <div class="col-md-3 mb-2">
                                    <b-form-group label="Subcategory" label-for="missing-subcategory">
                                        <b-form-select
                                            :id="'missing-subcategory-' + index"
                                            v-model="missing.subcategory_id"
                                            :options="missing.subcategoryOptions || []"
                                            @change="updateMissingProductFields(index)"
                                            :disabled="missing.saved || !missing.category_id"
                                        >
                                            <option :value="null">Select Subcategory</option>
                                        </b-form-select>
                                        <small v-if="!missing.category_id" class="text-muted">Select category first</small>
                                    </b-form-group>
                                </div>
                                <div class="col-md-2 mb-2">
                                    <b-form-group label="FOB Price ($)" label-for="missing-price" :state="missing.price > 0">
                                        <b-form-input
                                            :id="'missing-price-' + index"
                                            v-model="missing.price"
                                            type="number"
                                            step="0.01"
                                            placeholder="0.00"
                                            required
                                            :readonly="missing.saved"
                                            :state="missing.price > 0"
                                        ></b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col-md-2 mb-2">
                                    <b-form-group label="Selling Price ($)" label-for="missing-selling-price">
                                        <b-form-input
                                            :id="'missing-selling-price-' + index"
                                            v-model="missing.selling_price"
                                            type="number"
                                            step="0.01"
                                            placeholder="0.00"
                                            :readonly="missing.saved"
                                        ></b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col-md-2 mb-2">
                                    <b-form-group label="Cubes" label-for="missing-cubes" :state="missing.cubes > 0">
                                        <b-form-input
                                            :id="'missing-cubes-' + index"
                                            v-model="missing.cubes"
                                            type="number"
                                            step="0.001"
                                            placeholder="0.000"
                                            :readonly="missing.saved"
                                            :state="missing.cubes > 0"
                                        ></b-form-input>
                                    </b-form-group>
                                </div>
                                  <div class="col-md-2 mb-2">
                                    <b-form-group label="Qty/Box" label-for="missing-qty-per-box">
                                        <b-form-input
                                            :id="'missing-qty-per-box-' + index"
                                            v-model="missing.quantity_per_box"
                                            type="number"
                                            min="1"
                                            placeholder="1"
                                            :readonly="missing.saved"
                                        ></b-form-input>
                                    </b-form-group>
                                </div>
                            </div>

                            <!-- Qty/Box and Description -->
                            <div class="row">
                                <div class="col-md-3 mb-2">
                                    <b-form-group label="Vendor" label-for="missing-vendor">
                                        <b-form-select
                                            :id="'missing-vendor-' + index"
                                            v-model="missing.vendor_id"
                                            :options="vendorOptions"
                                            placeholder="Select vendor"
                                            :disabled="missing.saved || missing.saving"
                                        >
                                            <option :value="null">Select Vendor</option>
                                        </b-form-select>
                                    </b-form-group>
                                </div>
                              
                                <div class="col-md-8 mb-2">
                                    <b-form-group label="Product Description">
                                        <div class="d-flex">
                                            <b-textarea
                                                v-model="missing.product_description"
                                                rows="2"
                                                placeholder="Product description (auto-generated or manual)"
                                                :readonly="missing.saved"
                                                class="flex-grow-1"
                                            ></b-textarea>
                                            <b-button 
                                                size="sm" 
                                                variant="outline-primary" 
                                                @click="generateProductDescriptionOnly(index)"
                                                :disabled="missing.saved || !missing.category_id"
                                                class="ml-1 align-self-start"
                                                style="height: 38px;"
                                                title="Auto-generate Description">
                                                <b-icon-arrow-repeat></b-icon-arrow-repeat>
                                            </b-button>
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>

                            <!-- Optional Fields -->
                            <b-button 
                                v-b-toggle="'missing-opt-'+index" 
                                variant="link" 
                                size="sm" 
                                class="text-decoration-none p-0 mb-2"
                                :disabled="missing.saved"
                            >
                                <b-icon-chevron-down></b-icon-chevron-down> Advanced Fields
                            </b-button>
                            <b-collapse :id="'missing-opt-'+index">
                                <div class="row mt-2">
                                    <div class="col-md-3 mb-2">
                                        <b-form-group label="Type">
                                            <b-form-select 
                                                v-model="missing.type_id" 
                                                :options="missing.typeOptions || []"
                                                @change="generateSkuAndDescription(index)"
                                                :disabled="missing.saved || !missing.category_id"
                                            >
                                                <option :value="null">Select Type</option>
                                            </b-form-select>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-3 mb-2">
                                        <b-form-group label="Color">
                                            <b-form-select 
                                                v-model="missing.color_id" 
                                                :options="missing.colorOptions || []"
                                                @change="generateSkuAndDescription(index)"
                                                :disabled="missing.saved || !missing.category_id"
                                            >
                                                <option :value="null">Select Color</option>
                                            </b-form-select>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-3 mb-2">
                                        <b-form-group label="Material">
                                            <b-form-select 
                                                v-model="missing.material_id" 
                                                :options="missing.materialOptions || []"
                                                @change="generateSkuAndDescription(index)"
                                                :disabled="missing.saved || !missing.category_id"
                                            >
                                                <option :value="null">Select Material</option>
                                            </b-form-select>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-3 mb-2">
                                        <b-form-group label="Size">
                                            <b-form-select 
                                                v-model="missing.size_id" 
                                                :options="missing.sizeOptions || []"
                                                @change="generateSkuAndDescription(index)"
                                                :disabled="missing.saved || !missing.category_id"
                                            >
                                                <option :value="null">Select Size</option>
                                            </b-form-select>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-3 mb-2">
                                        <b-form-group label="Style">
                                            <b-form-select 
                                                v-model="missing.style_id" 
                                                :options="missing.styleOptions || []"
                                                @change="generateSkuAndDescription(index)"
                                                :disabled="missing.saved || !missing.category_id"
                                            >
                                                <option :value="null">Select Style</option>
                                            </b-form-select>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-3 mb-2">
                                        <b-form-group label="Vendor SKU">
                                            <b-form-input 
                                                v-model="missing.vendor_sku" 
                                                placeholder="Vendor SKU"
                                                :disabled="missing.saved"
                                            ></b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-3 mb-2">
                                        <b-form-group label="Spiff ($)">
                                            <b-form-input 
                                                v-model="missing.spiff" 
                                                type="number" 
                                                step="0.01"
                                                placeholder="0.00"
                                                :disabled="missing.saved"
                                            ></b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-3 mb-2">
                                        <b-form-group label="Height (in)">
                                            <b-form-input 
                                                v-model="missing.height" 
                                                type="number" 
                                                step="0.01"
                                                placeholder="0.00"
                                                :disabled="missing.saved"
                                            ></b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-3 mb-2">
                                        <b-form-group label="Width (in)">
                                            <b-form-input 
                                                v-model="missing.width" 
                                                type="number" 
                                                step="0.01"
                                                placeholder="0.00"
                                                :disabled="missing.saved"
                                            ></b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-3 mb-2">
                                        <b-form-group label="Depth (in)">
                                            <b-form-input 
                                                v-model="missing.depth" 
                                                type="number" 
                                                step="0.01"
                                                placeholder="0.00"
                                                :disabled="missing.saved"
                                            ></b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-3 mb-2">
                                        <b-form-group label="Weight (lbs)">
                                            <b-form-input 
                                                v-model="missing.weight" 
                                                type="number" 
                                                step="0.1"
                                                placeholder="0.0"
                                                :disabled="missing.saved"
                                            ></b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-3 mb-2">
                                        <b-form-group label="Assembly Time (min)">
                                            <b-form-input 
                                                v-model="missing.assembly_time" 
                                                type="number"
                                                placeholder="Minutes"
                                                :disabled="missing.saved"
                                            ></b-form-input>
                                        </b-form-group>
                                    </div>
                                </div>
                            </b-collapse>

                            <!-- Low Inventory Alert -->
                            <div v-if="missing.saved && missing.product_id" class="mt-3 pt-3 border-top">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <span class="text-success">
                                            <b-icon-check-circle></b-icon-check-circle>
                                            Product created! ID: {{ missing.product_id }}
                                        </span>
                                        <span v-if="missing.barcode_image_url" class="ml-2">
                                            <b-icon-upc-scan></b-icon-upc-scan>
                                            Barcode generated
                                        </span>
                                    </div>
                                    <b-button 
                                        size="sm" 
                                        variant="warning" 
                                        @click="showLowInventoryAlertForMissing(index)"
                                        class="px-3"
                                    >
                                        <b-icon-exclamation-triangle></b-icon-exclamation-triangle>
                                        Configure Inventory Alert
                                    </b-button>
                                </div>
                            </div>

                            <!-- Save Button -->
                            <div class="text-right mt-3">
                                <b-button
                                    size="sm"
                                    variant="outline-danger"
                                    @click="removeMissingProduct(index)"
                                    :disabled="missing.saving || missing.saved"
                                    class="mr-2"
                                >
                                    <b-icon-trash></b-icon-trash> Remove
                                </b-button>
                                <b-button 
                                    size="md" 
                                    variant="success" 
                                    @click="saveMissingProduct(index)"
                                    :disabled="!isMissingProductValid(missing) || missing.saving || missing.saved"
                                    class="px-4"
                                >
                                    <b-spinner small v-if="missing.saving" class="mr-1"></b-spinner>
                                    {{ missing.saving ? 'Saving...' : (missing.saved ? 'Saved ✓' : 'Create Product') }}
                                </b-button>
                            </div>
                        </div>
                    </div>

                    <!-- Selected Items Summary -->
                    <div class="row mb-3">
                        <div class="col-md-12">
                            <h6>Selected Items ({{ selectedItems.length }})</h6>
                            <div class="selected-items-container" style="max-height: 200px; overflow-y: auto;">
                                <div v-for="(item, index) in selectedItems" :key="index" class="selected-item d-flex justify-content-between align-items-center border-bottom py-1">
                                    <span>
                                        <span v-if="item.updated_sku" class="text-success">
                                            <b-icon-arrow-right-short></b-icon-arrow-right-short>
                                            {{ item.updated_sku }}
                                        </span>
                                        <span v-else>{{ item.product_sku }}</span>
                                        - {{ item.product_name }} (Qty: {{ item.quantity }})
                                    </span>
                                    <span>
                                        <span v-if="!item.product_exists" class="text-danger ml-2">
                                            <b-icon-exclamation-circle></b-icon-exclamation-circle>
                                            <strong>Missing!</strong>
                                        </span>
                                        <span v-else-if="item.merchandise_status === 3" class="text-warning ml-2">
                                            <b-icon-exclamation-triangle></b-icon-exclamation-triangle>
                                            Special
                                        </span>
                                        <span v-else-if="item.merchandise_status === 2" class="text-primary ml-2">
                                            <b-icon-arrow-right-short></b-icon-arrow-right-short>
                                            Backorder
                                        </span>
                                        <span v-else-if="item.updated_sku" class="text-success ml-2">
                                            <b-icon-check-circle></b-icon-check-circle>
                                            Updated: {{ item.updated_sku }}
                                        </span>
                                        <span v-else class="text-success ml-2">
                                            <b-icon-check-circle></b-icon-check-circle>
                                            OK
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- PDF Generation -->
                    <div class="row mb-3">
                        <div class="col-md-12 d-flex justify-content-between align-items-center">
                            <b-form-group class="mb-0">
                                <b-form-checkbox v-model="vendorPOForm.sendEmail">
                                    Send PDF via Email
                                </b-form-checkbox>
                            </b-form-group>
                            <b-button
                                v-if="allFieldsFilled"
                                variant="info"
                                @click.stop.prevent="generatePDF"
                                class="ml-2"
                            >
                                Generate and View PDF
                            </b-button>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="vendorPOForm.sendEmail">
                        <div class="col-md-12">
                            <b-form-group label="Email Address" label-for="email">
                                <b-form-input
                                    id="email"
                                    v-model="vendorPOForm.email"
                                    type="email"
                                    placeholder="Enter email address"
                                    :state="vendorPOForm.sendEmail ? !!vendorPOForm.email : null"
                                    class="custom-email-width"
                                ></b-form-input>
                                <b-form-invalid-feedback>
                                    Valid email is required when sending via email
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                    </div>

                    <hr>

                    <div class="d-flex justify-content-end mt-4">
                        <b-button variant="secondary" @click="$bvModal.hide('create-vendor-po-modal')" class="mr-2">
                            Cancel
                        </b-button>
                        <b-button
                            variant="primary"
                            @click.stop.prevent="createVendorPO"
                            :disabled="!vendorPOForm.poNumber || !vendorPOForm.receivingLocation || !vendorPOForm.shipping_location || !vendorPOForm.billing_location || isCreatingPO || hasUnsavedMissingProducts"
                        >
                            <b-spinner small v-if="isCreatingPO" class="mr-2"></b-spinner>
                            {{ isCreatingPO ? 'Creating PO...' : 'Create Purchase Order' }}
                        </b-button>
                    </div>
                </b-form>
            </b-modal>

            <!-- Low Inventory Alert Modal -->
            <b-modal 
                v-model="showLowInventoryModal" 
                title="Low Inventory Alert Configuration" 
                size="lg"
                @ok="saveLowInventoryAlert"
                @hidden="resetLowInventoryModal"
                centered>
                
                <div v-if="currentAlertProduct" class="low-inventory-form">
                    <div class="form-group mb-3">
                        <label class="form-label required">Product</label>
                        <b-input 
                            :value="currentAlertProduct.product_sku || 'N/A'" 
                            readonly 
                            class="bg-light">
                        </b-input>
                        <small class="text-muted">{{ currentAlertProduct.product_name || 'No description' }}</small>
                    </div>
                    
                    <div class="form-group mb-3">
                        <label class="form-label required">Alert Type</label>
                        <b-form-radio-group 
                            v-model="alertConfig.alert_type"
                            :options="alertTypeOptions"
                            buttons
                            button-variant="outline-primary"
                            size="sm">
                        </b-form-radio-group>
                    </div>
                    
                    <div class="form-group mb-3">
                        <label class="form-label required">Threshold Quantity</label>
                        <b-input 
                            v-model.number="alertConfig.threshold_quantity"
                            type="number"
                            min="1"
                            step="1"
                            placeholder="Enter minimum quantity before alert"
                            :state="alertConfig.threshold_quantity > 0 ? null : false">
                        </b-input>
                        <small class="text-muted">Alert will trigger when inventory falls below this quantity</small>
                    </div>
                    
                    <div class="form-group mb-3">
                        <label class="form-label">Notification Method</label>
                        <b-form-checkbox-group v-model="alertConfig.notification_methods">
                            <b-form-checkbox value="email">Email Alert</b-form-checkbox>
                            <b-form-checkbox value="dashboard">Dashboard Notification</b-form-checkbox>
                            <b-form-checkbox value="sms">SMS Alert</b-form-checkbox>
                        </b-form-checkbox-group>
                    </div>
                    
                    <div class="form-group mb-3" v-if="alertConfig.notification_methods.includes('email')">
                        <label class="form-label">Alert Email(s)</label>
                        <b-input 
                            v-model="alertConfig.alert_emails"
                            placeholder="Enter email addresses (comma separated)">
                        </b-input>
                        <small class="text-muted">Leave empty to use default admin email</small>
                    </div>
                    
                    <div class="form-group mb-3">
                        <label class="form-label">Reminder Frequency</label>
                        <b-form-select 
                            v-model="alertConfig.reminder_frequency"
                            :options="reminderOptions"
                            size="sm">
                        </b-form-select>
                        <small class="text-muted">How often to send reminders for this product</small>
                    </div>
                    
                    <div class="form-group mb-3">
                        <label class="form-label">Additional Notes</label>
                        <b-textarea 
                            v-model="alertConfig.notes"
                            rows="2"
                            placeholder="Optional notes for inventory management">
                        </b-textarea>
                    </div>
                </div>
                
                <div v-else class="text-center py-4">
                    <b-icon-exclamation-triangle-fill variant="warning" font-scale="3"></b-icon-exclamation-triangle-fill>
                    <h5 class="mt-3">Loading product information...</h5>
                </div>
                
                <template slot="modal-footer">
                    <b-button variant="secondary" @click="showLowInventoryModal = false">
                        Cancel
                    </b-button>
                    <b-button variant="warning" @click="saveLowInventoryAlert" :disabled="!isAlertConfigValid || !currentAlertProduct">
                        <b-icon-bell></b-icon-bell> Save Alert
                    </b-button>
                </template>
            </b-modal>

            <!-- Barcode Scanner Modal -->
            <b-modal 
                id="modal-product-barcode-scanner" 
                title="Scan Product Barcode" 
                size="lg" 
                hide-footer
                @shown="startProductScanner"
                @hidden="stopProductScanner">
                <div class="scanner-container">
                    <QuaggaScanner 
                        ref="productQuaggaScanner"
                        @scan="handleProductBarcodeScan"
                        :facingMode="productCurrentCamera"
                    />
                    
                    <div class="mt-3 text-center">
                        <div class="mt-2">
                            <b-button 
                                size="sm" 
                                variant="outline-secondary" 
                                @click="toggleProductCamera">
                                Switch Camera
                            </b-button>
                            <b-button 
                                size="sm" 
                                variant="outline-danger" 
                                @click="stopProductScanner" 
                                class="ml-2">
                                Cancel
                            </b-button>
                        </div>
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import QuaggaScanner from "@/components/importables/QuaggaScanner.vue";
    import { 
        BIconFunnelFill, BIconExclamationTriangleFill, BIconExclamationCircle, 
        BIconCheckCircle, BIconExclamationTriangle, BIconArrowRightShort,
        BIconTrash, BIconX, BIconCloudUpload, BIconImage, BIconUpcScan,
        BIconCamera, BIconSearch, BIconChevronDown, BIconPlus, BIconBell,
        BIconInfoCircle, BIconBoxSeam, BIconCollection, BIconTag,
        BIconRulers, BIconEye, BIconArrowRepeat
    } from 'bootstrap-vue'

    export default {
        name: "ListCustomerOrdersEnhanced",
        components: { 
            Loading, 
            DatePicker, 
            flatPickr,
            QuaggaScanner,
            BIconFunnelFill, BIconExclamationTriangleFill, BIconExclamationCircle,
            BIconCheckCircle, BIconExclamationTriangle, BIconArrowRightShort,
            BIconTrash, BIconX, BIconCloudUpload, BIconImage, BIconUpcScan,
            BIconCamera, BIconSearch, BIconChevronDown, BIconPlus, BIconBell,
            BIconInfoCircle, BIconBoxSeam, BIconCollection, BIconTag,
            BIconRulers, BIconEye, BIconArrowRepeat
        },
        data: function(){
            return {
                packet: {},
                vendorPOForm: {
                    poNumber: '',
                    receivingLocation: null,
                    eta: null,
                    status: 1,
                    sendEmail: false,
                    email: '',
                    shipping_location: null,
                    billing_location: null,
                },
                isCreatingPO: false,
                items: [],
                items_being_loaded: null,
                search_keyword: "",
                vendor_id: null,
                schedule_date: null,
                ordering_location: null,
                receiving_location: null,
                vendor_order_status_filter: "open",
                user_is_admin: false,
                user_location_id: null,
                order_type_filter: null,
                pdfBlob: null,
                pdfUrl: null,
                po_status_filter: "without_po",
                missingProducts: [],
                merchandise_status_filter: null,
                
                // Category data
                categoryOptions: [],
                vendorOptions: [],
                allCategories: [],
                categoryCodes: {},
                skuCounters: {},
                modalVisible: false,
                
                // Cached options
                categoryTypeOptions: {},
                categoryColorOptions: {},
                categoryMaterialOptions: {},
                categorySizeOptions: {},
                categorySubcategoryOptions: {},
                categoryStyleOptions: {},
                
                // Code mappings for SKU generation
                typeCodes: {},
                colorCodes: {},
                materialCodes: {},
                sizeCodes: {},
                subcategoryCodes: {},
                styleCodes: {},
                
                // Order options
                order_type_options: [
                    { value: null, text: "ALL" },
                    { value: "home_delivery", text: "HOME DELIVERY" },
                    { value: "store_pickup", text: "STORE PICKUP" },
                ],
                po_status_options: [
                    { value: "without_po", text: "Without PO" },
                    { value: "with_po", text: "With PO" },
                    { value: "all", text: "All Items" }
                ],
                merchandise_status_options: [
                    { value: null, text: "ALL" },
                    { value: 2, text: "BACKORDER" },
                    { value: 3, text: "SPECIAL ORDER" }
                ],
                vendor_order_statuses: [
                    {value: 1, text: "NEW"},
                    {value: 2, text: "ORDERED"},
                    {value: 3, text: "SCHEDULED"},
                    {value: 4, text: "IN-TRANSIT"},
                    {value: 5, text: "PARTIAL"},
                    {value: 6, text: "RECEIVED"},
                    {value: 7, text: "COMPLETED"},
                    {value: 8, text: "ARCHIVED"},
                ],
                vendor_order_statuses_dict: {
                    1: "NEW",
                    2: "ORDERED",
                    3: "SCHEDULED",
                    4: "IN-TRANSIT",
                    5: "PARTIAL",
                    6: "RECEIVED",
                    7: "COMPLETED",
                    8: "ARCHIVED"
                },
                
                // Selection state
                selectedItems: [],
                selectAll: false,
                selectedVendor: null,
                showItemsInPO: false,
                filtersVisible: false,
                isMobile: false,
                
                // Low Inventory Alert
                showLowInventoryModal: false,
                currentAlertProduct: null,
                currentAlertProductIndex: null,
                alertConfig: {
                    alert_type: 'threshold',
                    threshold_quantity: 10,
                    notification_methods: ['email', 'dashboard'],
                    alert_emails: '',
                    notes: '',
                    reminder_frequency: 'weekly'
                },
                alertTypeOptions: [
                    { text: 'Threshold Alert', value: 'threshold' },
                    { text: 'Percentage Alert', value: 'percentage' },
                    { text: 'Reorder Point', value: 'reorder_point' }
                ],
                reminderOptions: [
                    { text: 'Weekly', value: 'weekly' },
                    { text: 'Bi-weekly', value: 'biweekly' },
                    { text: 'Monthly', value: 'monthly' }
                ],
                
                // Barcode scanner
                productCurrentCamera: 'environment',
                currentMissingProductIndex: null,
            }
        },
        mounted() {
            this.handleResize()
            window.addEventListener('resize', this.handleResize)
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize)
        },
        computed: {
            filteredVendors() {
                if (!this.items || this.items.length === 0) return this.vendorOptions;

                const vendorsWithoutPO = [...new Set(
                    this.items
                        .filter(item =>
                            !item.is_in_po &&
                            item.vendor_order_status >= 1 && item.vendor_order_status <= 5
                        )
                        .map(item => item.vendor_id)
                )];

                return [
                    { value: null, text: "ALL" },
                    ...this.vendorOptions.filter(vendor =>
                        vendor.value !== null &&
                        vendorsWithoutPO.includes(vendor.value)
                    )
                ];
            },
            filteredShippingLocations() {
                return function() {
                    return this.shipping_location_options;
                };
            },
            filteredReceivingLocations() {
                return function() {
                    const shipToLocation = this.vendorPOForm.shipping_location;

                    if (!shipToLocation) {
                        return this.receiving_location_options;
                    }

                    const shipToText = this.getLocationText(shipToLocation);
                    
                    if (shipToText === 'MECCA WHOLESALE') {
                        return this.receiving_location_options.filter(loc =>
                            ['9TH ST ', '101 WH', 'FOLCROFT'].some(whLocation =>
                                loc.text.includes(whLocation)
                            )
                        );
                    } else {
                        return this.receiving_location_options.filter(loc =>
                            loc.value === shipToLocation || loc.text === shipToText
                        );
                    }
                };
            },
            billing_location_options() {
                const options = [];
                options.push({ value: 47, text: "MECCA WHOLESALE" });

                const storeLocations = this.shipping_location_options.filter(loc =>
                    loc.value !== 47 &&
                    loc.text !== 'MECCA WHOLESALE' &&
                    loc.value !== null &&
                    !loc.text.includes('FOLCROFT') &&
                    !loc.text.includes('9TH ST') &&
                    !loc.text.includes('9th ST')
                );

                options.push(...storeLocations);
                return options;
            },
            ordering_location_options() {
                const excludedLocationTexts = ['ALL', 'OUT OF STOCK', 'ONLINE SALES', 'MECCA SHIPPING', '9TH ST ', '101 WH', 'FOLCROFT'];
                let options = this.packet.locations ? [...this.packet.locations] : [];
                options = options.filter(loc => !excludedLocationTexts.includes(loc.text));
                return options;
            },
            receiving_location_options() {
                const excludedLocationTexts = ['ALL', 'OUT OF STOCK', 'ONLINE SALES', '', '', ' ALL '];
                let options = this.packet.locations ? [...this.packet.locations] : [];
                options = options.filter(loc =>
                    !excludedLocationTexts.includes(loc.text) || loc.text === "MECCA WHOLESALE"
                );
                return options;
            },
            shipping_location_options() {
                const excludedLocationTexts = [' ALL', 'OUT OF STOCK', 'ONLINE SALES', '', '', '', 'MECCA SHIPPING'];
                let options = this.packet.locations ? [...this.packet.locations] : [];
                options = options.filter(loc => !excludedLocationTexts.includes(loc.text));

                const warehouseLocations = ['9TH ST ', '101 WH', 'FOLCROFT'];
                const hasMeccaWholesale = options.some(loc => loc.text === 'MECCA WHOLESALE');

                if (!hasMeccaWholesale) {
                    options = options.filter(loc =>
                        !warehouseLocations.some(wh => loc.text.includes(wh))
                    );

                    const meccaOption = this.packet.locations.find(loc =>
                        warehouseLocations.some(wh => loc.text.includes(wh))
                    );

                    if (meccaOption) {
                        options.unshift({
                            value: 47,
                            text: 'MECCA WHOLESALE'
                        });
                    }
                }

                return options;
            },
            vendor_order_status_filter_options() {
                let options = [...this.vendor_order_statuses];
                options.unshift({ value: "open", text: "OPEN" });
                return options;
            },
            filtered() {
                let that = this;

                if (!this.vendor_id && this.selectedItems.length > 0) {
                    this.selectedItems = [];
                    this.selectAll = false;
                }

                if ((this.search_keyword == "" || !this.search_keyword)
                    && !this.vendor_id
                    && !this.ordering_location
                    && !this.receiving_location
                    && !this.vendor_order_status_filter
                    && !this.order_type_filter
                    && this.po_status_filter === "without_po"
                    && !this.merchandise_status_filter) {
                    return this.items.filter(item => !item.is_in_po).slice(0, 200)
                }
                else {
                    let search_keyword = this.search_keyword.toUpperCase();
                    const filteredItems = this.items.filter(function(d){
                        let poFilterPassed = true;
                        if (that.po_status_filter === "without_po") {
                            poFilterPassed = !d.is_in_po;
                        } else if (that.po_status_filter === "with_po") {
                            poFilterPassed = d.is_in_po;
                        }

                        let merchandiseFilterPassed = true;
                        if (that.merchandise_status_filter !== null) {
                            merchandiseFilterPassed = d.merchandise_status == that.merchandise_status_filter;
                        }

                        return (
                            poFilterPassed &&
                            merchandiseFilterPassed &&
                            ((that.vendor_id) ? d.vendor_id == that.vendor_id : true ) &&
                            ((that.ordering_location) ?
                                (d.ordering_locsub &&
                                 d.ordering_locsub.split('|').includes(that.ordering_location.toString())) : true ) &&
                            ((that.receiving_location) ? d.receiving_locsub == that.receiving_location : true ) &&
                            ((that.vendor_order_status_filter == "open")
                              ? [0,1,2,3,4,5].includes(d.vendor_order_status)
                              : (that.vendor_order_status_filter !== null)
                              ? d.vendor_order_status == that.vendor_order_status_filter
                              : true ) &&
                            ((that.order_type_filter) ? d.order_type == that.order_type_filter : true ) &&
                            ((search_keyword) ? (
                                (
                                    d.invoice_id.includes(search_keyword)
                                ) ||
                                (
                                    d.product_sku.includes(search_keyword)
                                ) ||
                                (
                                    d.product_name.includes(search_keyword)
                                ) ||
                                (
                                    d.customer_name.includes(search_keyword)
                                ) ||
                                (
                                    d.customer_phone.includes(search_keyword)
                                )
                            ) : true )
                        )
                    }).slice(0, 200);

                    this.selectedItems = this.selectedItems.filter(item =>
                        filteredItems.some(fi =>
                            fi.invoice_id === item.invoice_id &&
                            fi.itemid === item.itemid
                        )
                    );

                    if (filteredItems.length === 0) {
                        this.selectedItems = [];
                        this.selectAll = false;
                    }

                    return filteredItems;
                }
            },
            showCreateVendorPOButton() {
                return this.selectedVendor && this.selectedItems.length > 0;
            },
            allFieldsFilled() {
                return this.vendorPOForm.poNumber &&
                 this.vendorPOForm.receivingLocation &&
                 this.vendorPOForm.shipping_location &&
                this.vendorPOForm.billing_location
            },
            hasUnsavedMissingProducts() {
                return this.missingProducts.some(p => !p.saved && !p.saving);
            },
            isAlertConfigValid() {
                return this.currentAlertProduct && 
                       this.alertConfig.threshold_quantity > 0 && 
                       this.alertConfig.alert_type &&
                       this.alertConfig.threshold_quantity !== null &&
                       this.alertConfig.threshold_quantity !== '';
            }
        },
        methods: {
            // ================================================================
            // VENDOR LOADING
            // ================================================================
            
            loadVendors() {
                console.log("Loading vendors from packet:", this.packet.vendors)
                
                if (this.packet.vendors && this.packet.vendors.length > 0) {
                    this.vendorOptions = this.packet.vendors.map(vendor => ({
                        value: vendor.value,
                        text: vendor.text
                    }))
                    this.vendorOptions.unshift({ value: null, text: "Select Vendor" })
                    console.log("Vendors loaded from packet:", this.vendorOptions.length)
                    return
                }
                
                this.fetchVendorsFromAPI()
            },

            fetchVendorsFromAPI() {
                const path = "/api/vendor/get_vendors/"
                const that = this
                
                const successCallback = function(response) {
                    if (response.data && response.data.result) {
                        that.vendorOptions = response.data.result.map(vendor => ({
                            value: vendor.id,
                            text: vendor.name || vendor.vendor_name
                        }))
                        that.vendorOptions.unshift({ value: null, text: "Select Vendor" })
                        console.log("Vendors fetched from API:", that.vendorOptions.length)
                    } else {
                        that.vendorOptions = [{ value: null, text: "Select Vendor" }]
                    }
                }
                
                const errorCallback = function(error) {
                    console.error("Failed to load vendors:", error)
                    that.vendorOptions = [{ value: null, text: "Select Vendor" }]
                }
                
                Requestor.getSyncP(path, {}, this, successCallback, errorCallback)
            },

            // ================================================================
            // CATEGORY DATA LOADING
            // ================================================================
            
            loadAllCategoryData() {
                console.log("Loading all category data...")
                this.loadCategories()
            },

            loadCategories() {
                if (this.packet && 
                    this.packet.categories && 
                    Array.isArray(this.packet.categories) && 
                    this.packet.categories.length > 0) {
                    
                    console.log("Loading categories from packet:", this.packet.categories.length)
                    
                    this.allCategories = this.packet.categories
                    
                    this.categoryOptions = this.packet.categories.map(cat => ({
                        value: cat.value || cat.id,
                        text: cat.text || cat.name || 'Unknown'
                    }))
                    
                    this.categoryOptions.unshift({ value: null, text: "ALL CATEGORIES" })
                    
                    if (!this.categoryCodes) this.categoryCodes = {}
                    this.packet.categories.forEach(cat => {
                        const catId = cat.value || cat.id
                        if (catId) {
                            const catName = cat.text || cat.name || 'Unknown'
                            const code = cat.code || cat.category_code || catName.substring(0, 1).toUpperCase()
                            this.categoryCodes[catId] = {
                                code: code,
                                name: catName
                            }
                            console.log(`Category: ${catName} (ID: ${catId}) Code: ${code}`)
                        }
                    })
                    
                    console.log("Categories loaded from packet:", this.categoryOptions.length - 1, "categories")
                    return
                }

                console.log("No categories in packet, fetching from API...")
                const path = "/api/category/get_categories/"
                const that = this
                
                const successCallback = function(response) {
                    console.log("Categories API response:", response)
                    if (response.data && response.data.result && Array.isArray(response.data.result)) {
                        that.allCategories = response.data.result
                        that.categoryOptions = response.data.result.map(cat => ({
                            value: cat.value || cat.id || cat.category_id,
                            text: cat.text || cat.name || cat.category_name || 'Unknown'
                        }))
                        that.categoryOptions.unshift({ value: null, text: "ALL CATEGORIES" })
                        
                        if (!that.categoryCodes) that.categoryCodes = {}
                        response.data.result.forEach(cat => {
                            const catId = cat.value || cat.id || cat.category_id
                            if (catId) {
                                const catName = cat.text || cat.name || cat.category_name || 'Unknown'
                                const code = cat.code || cat.category_code || catName.substring(0, 1).toUpperCase()
                                that.categoryCodes[catId] = {
                                    code: code,
                                    name: catName
                                }
                            }
                        })
                        console.log("Categories loaded from API:", that.categoryOptions.length - 1, "categories")
                    } else {
                        console.warn("No categories in API response")
                        that.categoryOptions = [{ value: null, text: "Select Category" }]
                    }
                }
                
                const errorCallback = function(error) {
                    console.error("Failed to load categories:", error)
                    that.categoryOptions = [{ value: null, text: "Select Category" }]
                }
                
                Requestor.getSyncP(path, {}, this, successCallback, errorCallback)
            },

            loadSubcategoriesForCategory(categoryId, callback) {
                if (!categoryId) {
                    if (callback) callback([])
                    return
                }

                if (this.categorySubcategoryOptions[categoryId]) {
                    if (callback) callback(this.categorySubcategoryOptions[categoryId])
                    return
                }

                const path = "/api/product/get_subcategories/"
                const data = { category_id: categoryId }
                const that = this

                const successCallback = function(response) {
                    if (!response.data.error) {
                        const options = response.data.result.map(subcat => ({
                            value: subcat.id,
                            text: subcat.subcategory
                        }))
                        options.unshift({ value: null, text: "Select Subcategory" })
                        that.categorySubcategoryOptions[categoryId] = options
                        
                        response.data.result.forEach(subcat => {
                            that.subcategoryCodes[subcat.id] = {
                                code: subcat.code || subcat.subcategory_code || subcat.subcategory.substring(0, 3).toUpperCase(),
                                name: subcat.subcategory
                            }
                        })
                        
                        if (callback) callback(options)
                    } else {
                        if (callback) callback([])
                    }
                }

                const errorCallback = function(error) {
                    console.error("Failed to load subcategories:", error)
                    if (callback) callback([])
                }

                Requestor.postSyncP(path, data, this, successCallback, errorCallback)
            },

            loadTypesForCategory(categoryId, callback) {
                if (!categoryId) {
                    if (callback) callback([])
                    return
                }

                if (this.categoryTypeOptions[categoryId]) {
                    if (callback) callback(this.categoryTypeOptions[categoryId])
                    return
                }

                const path = "/api/product/get_category_types/"
                const data = { category_id: categoryId }
                const that = this

                const successCallback = function(response) {
                    if (!response.data.error) {
                        const options = response.data.result.map(type => ({
                            value: type.id,
                            text: type.type_name
                        }))
                        options.unshift({ value: null, text: "Select Type" })
                        that.categoryTypeOptions[categoryId] = options
                        
                        response.data.result.forEach(type => {
                            that.typeCodes[type.id] = {
                                code: type.code || type.type_code || type.type_name.substring(0, 3).toUpperCase(),
                                name: type.type_name
                            }
                        })
                        
                        if (callback) callback(options)
                    } else {
                        if (callback) callback([])
                    }
                }

                const errorCallback = function(error) {
                    console.error("Failed to load types:", error)
                    if (callback) callback([])
                }

                Requestor.postSyncP(path, data, this, successCallback, errorCallback)
            },

            loadColorsForCategory(categoryId, callback) {
                if (!categoryId) {
                    if (callback) callback([])
                    return
                }

                if (this.categoryColorOptions[categoryId]) {
                    if (callback) callback(this.categoryColorOptions[categoryId])
                    return
                }

                const path = "/api/product/get_category_colors/"
                const data = { category_id: categoryId }
                const that = this

                const successCallback = function(response) {
                    if (!response.data.error) {
                        const options = response.data.result.map(color => ({
                            value: color.id,
                            text: color.color_name,
                            code: color.code || color.color_code || color.color_name.substring(0, 2).toUpperCase()
                        }))
                        options.unshift({ value: null, text: "Select Color" })
                        that.categoryColorOptions[categoryId] = options
                        
                        response.data.result.forEach(color => {
                            const code = color.code || color.color_code || color.color_name.substring(0, 2).toUpperCase()
                            that.colorCodes[color.id] = {
                                code: code,
                                name: color.color_name
                            }
                        })
                        
                        if (callback) callback(options)
                    } else {
                        if (callback) callback([])
                    }
                }

                const errorCallback = function(error) {
                    console.error("Failed to load colors:", error)
                    if (callback) callback([])
                }

                Requestor.postSyncP(path, data, this, successCallback, errorCallback)
            },

            loadMaterialsForCategory(categoryId, callback) {
                if (!categoryId) {
                    if (callback) callback([])
                    return
                }

                if (this.categoryMaterialOptions[categoryId]) {
                    if (callback) callback(this.categoryMaterialOptions[categoryId])
                    return
                }

                const path = "/api/product/get_category_materials/"
                const data = { category_id: categoryId }
                const that = this

                const successCallback = function(response) {
                    if (!response.data.error) {
                        const options = response.data.result.map(material => ({
                            value: material.id,
                            text: material.material_name,
                            code: material.code || material.material_code || material.material_name.substring(0, 2).toUpperCase()
                        }))
                        options.unshift({ value: null, text: "Select Material" })
                        that.categoryMaterialOptions[categoryId] = options
                        
                        response.data.result.forEach(material => {
                            const code = material.code || material.material_code || material.material_name.substring(0, 2).toUpperCase()
                            that.materialCodes[material.id] = {
                                code: code,
                                name: material.material_name
                            }
                        })
                        
                        if (callback) callback(options)
                    } else {
                        if (callback) callback([])
                    }
                }

                const errorCallback = function(error) {
                    console.error("Failed to load materials:", error)
                    if (callback) callback([])
                }

                Requestor.postSyncP(path, data, this, successCallback, errorCallback)
            },

            loadSizesForCategory(categoryId, callback) {
                if (!categoryId) {
                    if (callback) callback([])
                    return
                }

                if (this.categorySizeOptions[categoryId]) {
                    if (callback) callback(this.categorySizeOptions[categoryId])
                    return
                }

                const path = "/api/product/get_category_sizes/"
                const data = { category_id: categoryId }
                const that = this

                const successCallback = function(response) {
                    if (!response.data.error) {
                        const options = response.data.result.map(size => ({
                            value: size.id,
                            text: size.size_name
                        }))
                        options.unshift({ value: null, text: "Select Size" })
                        that.categorySizeOptions[categoryId] = options
                        
                        response.data.result.forEach(size => {
                            that.sizeCodes[size.id] = {
                                code: size.code || size.size_code || size.size_name.substring(0, 2).toUpperCase(),
                                name: size.size_name
                            }
                        })
                        
                        if (callback) callback(options)
                    } else {
                        if (callback) callback([])
                    }
                }

                const errorCallback = function(error) {
                    console.error("Failed to load sizes:", error)
                    if (callback) callback([])
                }

                Requestor.postSyncP(path, data, this, successCallback, errorCallback)
            },

            loadStylesForCategory(categoryId, callback) {
                if (!categoryId) {
                    if (callback) callback([])
                    return
                }

                if (this.categoryStyleOptions[categoryId]) {
                    if (callback) callback(this.categoryStyleOptions[categoryId])
                    return
                }

                const path = "/api/product/get_category_styles/"
                const data = { category_id: categoryId }
                const that = this

                const successCallback = function(response) {
                    if (!response.data.error) {
                        const options = response.data.result.map(style => ({
                            value: style.id,
                            text: style.style_name
                        }))
                        options.unshift({ value: null, text: "Select Style" })
                        that.categoryStyleOptions[categoryId] = options
                        
                        response.data.result.forEach(style => {
                            that.styleCodes[style.id] = {
                                code: style.style_code || style.style_name.substring(0, 3).toUpperCase(),
                                name: style.style_name
                            }
                        })
                        
                        if (callback) callback(options)
                    } else {
                        if (callback) callback([])
                    }
                }

                const errorCallback = function(error) {
                    console.error("Failed to load styles:", error)
                    if (callback) callback([])
                }

                Requestor.postSyncP(path, data, this, successCallback, errorCallback)
            },

            loadMissingProductCategoryAttributes(index) {
                const missing = this.missingProducts[index]
                if (!missing || !missing.category_id) {
                    missing.subcategoryOptions = [{ value: null, text: "Select Subcategory" }]
                    missing.typeOptions = [{ value: null, text: "Select Type" }]
                    missing.colorOptions = [{ value: null, text: "Select Color" }]
                    missing.materialOptions = [{ value: null, text: "Select Material" }]
                    missing.sizeOptions = [{ value: null, text: "Select Size" }]
                    missing.styleOptions = [{ value: null, text: "Select Style" }]
                    return
                }

                const categoryId = missing.category_id

                this.loadSubcategoriesForCategory(categoryId, (options) => {
                    missing.subcategoryOptions = options || [{ value: null, text: "No subcategories" }]
                })

                this.loadTypesForCategory(categoryId, (options) => {
                    missing.typeOptions = options || [{ value: null, text: "No types" }]
                })

                this.loadColorsForCategory(categoryId, (options) => {
                    missing.colorOptions = options || [{ value: null, text: "No colors" }]
                })

                this.loadMaterialsForCategory(categoryId, (options) => {
                    missing.materialOptions = options || [{ value: null, text: "No materials" }]
                })

                this.loadSizesForCategory(categoryId, (options) => {
                    missing.sizeOptions = options || [{ value: null, text: "No sizes" }]
                })

                this.loadStylesForCategory(categoryId, (options) => {
                    missing.styleOptions = options || [{ value: null, text: "No styles" }]
                })

                if (missing._previousCategoryId && missing._previousCategoryId !== categoryId) {
                    missing.subcategory_id = null
                    missing.type_id = null
                    missing.color_id = null
                    missing.material_id = null
                    missing.size_id = null
                    missing.style_id = null
                }
                missing._previousCategoryId = categoryId
            },

            updateMissingProductFields(index) {
                const missing = this.missingProducts[index]
                if (!missing) return
                if (missing.category_id && missing.subcategory_id) {
                    this.generateSkuAndDescription(index)
                }
            },

            // ================================================================
            // SKU, NAME AND DESCRIPTION GENERATION - COMPLETE
            // ================================================================

            generateSkuAndDescription(index) {
                const missing = this.missingProducts[index]
                if (!missing) return
                
                if (!missing.category_id) {
                    this.$bvToast.toast("Please select a category first", {
                        title: "Info",
                        variant: "info",
                        autoHideDelay: 2000
                    })
                    return
                }
                
                this.generateProductSku(missing)
                this.generateProductNameAndDescription(missing)
                
                this.$bvToast.toast("SKU, Product Name and Description generated!", {
                    title: "Success",
                    variant: "success",
                    autoHideDelay: 1500
                })
            },

            generateProductDescriptionOnly(index) {
                const missing = this.missingProducts[index]
                if (!missing) return
                
                if (!missing.category_id) {
                    this.$bvToast.toast("Please select a category first", {
                        title: "Info",
                        variant: "info",
                        autoHideDelay: 2000
                    })
                    return
                }
                
                this.generateProductNameAndDescription(missing)
                
                this.$bvToast.toast("Product Name and Description generated!", {
                    title: "Success",
                    variant: "success",
                    autoHideDelay: 1500
                })
            },

            generateProductSku(missing) {
                if (!missing || !missing.category_id) return
                
                const category = this.allCategories.find(c => c.value === missing.category_id)
                const categoryCode = category ? (category.code || category.text.substring(0, 1).toUpperCase()) : "X"
                
                if (missing._skuGenerated && missing._skuNumber !== null) {
                    let typeCode = ""
                    if (missing.type_id && this.typeCodes && this.typeCodes[missing.type_id]) {
                        typeCode = this.typeCodes[missing.type_id].code || ""
                        typeCode = typeCode.charAt(0).toUpperCase()
                    }
                    
                    let colorCode = "00"
                    if (missing.color_id && this.colorCodes && this.colorCodes[missing.color_id]) {
                        colorCode = this.colorCodes[missing.color_id].code || "00"
                        if (colorCode.length > 2) colorCode = colorCode.substring(0, 2)
                        if (colorCode.length < 2) colorCode = colorCode.padEnd(2, '0')
                    }
                    
                    let materialCode = "00"
                    if (missing.material_id && this.materialCodes && this.materialCodes[missing.material_id]) {
                        materialCode = this.materialCodes[missing.material_id].code || "00"
                        if (materialCode.length > 2) materialCode = materialCode.substring(0, 2)
                        if (materialCode.length < 2) materialCode = materialCode.padEnd(2, '0')
                    }
                    
                    let sizeCode = ""
                    if (missing.size_id && this.sizeCodes && this.sizeCodes[missing.size_id]) {
                        sizeCode = this.sizeCodes[missing.size_id].code || ""
                        sizeCode = sizeCode.charAt(0).toUpperCase()
                    }
                    
                    let subcategoryCode = ""
                    if (missing.subcategory_id && this.subcategoryCodes && this.subcategoryCodes[missing.subcategory_id]) {
                        subcategoryCode = this.subcategoryCodes[missing.subcategory_id].code || ""
                        if (subcategoryCode) {
                            const words = subcategoryCode.split(' ')
                            if (words.length > 1) {
                                subcategoryCode = words.map(w => w.charAt(0).toUpperCase()).join('')
                            } else {
                                subcategoryCode = subcategoryCode.substring(0, 1).toUpperCase()
                            }
                        }
                    }
                    
                    const autoNumber = missing._skuNumber
                    
                    let sku = `${categoryCode}${typeCode}-${String(autoNumber).padStart(3, '0')}`
                    sku += `-${colorCode}`
                    sku += `-${materialCode}`
                    
                    if (sizeCode) {
                        sku += `-${sizeCode}`
                    }
                    
                    if (subcategoryCode) {
                        if (sizeCode) {
                            sku += `${subcategoryCode}`
                        } else {
                            sku += `-${subcategoryCode}`
                        }
                    }
                    
                    missing.new_sku = sku
                    return
                }
                
                let typeCode = ""
                if (missing.type_id && this.typeCodes && this.typeCodes[missing.type_id]) {
                    typeCode = this.typeCodes[missing.type_id].code || ""
                    typeCode = typeCode.charAt(0).toUpperCase()
                }
                
                let colorCode = "00"
                if (missing.color_id && this.colorCodes && this.colorCodes[missing.color_id]) {
                    colorCode = this.colorCodes[missing.color_id].code || "00"
                    if (colorCode.length > 2) colorCode = colorCode.substring(0, 2)
                    if (colorCode.length < 2) colorCode = colorCode.padEnd(2, '0')
                }
                
                let materialCode = "00"
                if (missing.material_id && this.materialCodes && this.materialCodes[missing.material_id]) {
                    materialCode = this.materialCodes[missing.material_id].code || "00"
                    if (materialCode.length > 2) materialCode = materialCode.substring(0, 2)
                    if (materialCode.length < 2) materialCode = materialCode.padEnd(2, '0')
                }
                
                let sizeCode = ""
                if (missing.size_id && this.sizeCodes && this.sizeCodes[missing.size_id]) {
                    sizeCode = this.sizeCodes[missing.size_id].code || ""
                    sizeCode = sizeCode.charAt(0).toUpperCase()
                }
                
                let subcategoryCode = ""
                if (missing.subcategory_id && this.subcategoryCodes && this.subcategoryCodes[missing.subcategory_id]) {
                    subcategoryCode = this.subcategoryCodes[missing.subcategory_id].code || ""
                    if (subcategoryCode) {
                        const words = subcategoryCode.split(' ')
                        if (words.length > 1) {
                            subcategoryCode = words.map(w => w.charAt(0).toUpperCase()).join('')
                        } else {
                            subcategoryCode = subcategoryCode.substring(0, 1).toUpperCase()
                        }
                    }
                }
                
                const counterKey = `${missing.category_id}_${missing.type_id || 'none'}`
                if (!this.skuCounters) {
                    this.skuCounters = {}
                }
                if (!this.skuCounters[counterKey]) {
                    this.skuCounters[counterKey] = 100
                }
                
                const autoNumber = this.skuCounters[counterKey]
                this.skuCounters[counterKey]++
                
                missing._skuNumber = autoNumber
                missing._skuGenerated = true
                
                let sku = `${categoryCode}${typeCode}-${String(autoNumber).padStart(3, '0')}`
                sku += `-${colorCode}`
                sku += `-${materialCode}`
                
                if (sizeCode) {
                    sku += `-${sizeCode}`
                }
                
                if (subcategoryCode) {
                    if (sizeCode) {
                        sku += `${subcategoryCode}`
                    } else {
                        sku += `-${subcategoryCode}`
                    }
                }
                
                missing.new_sku = sku
            },

           generateProductNameAndDescription(missing) {
    if (!missing.category_id) return
    
    const category = this.allCategories.find(c => c.value === missing.category_id)
    const categoryName = category ? category.text : ''
    const collectionName = missing.collection_name || ''
    
    const colorName = this.colorCodes[missing.color_id] ? this.colorCodes[missing.color_id].name : ''
    const materialName = this.materialCodes[missing.material_id] ? this.materialCodes[missing.material_id].name : ''
    const sizeName = this.sizeCodes[missing.size_id] ? this.sizeCodes[missing.size_id].name : ''
    const subcategoryName = this.subcategoryCodes[missing.subcategory_id] ? this.subcategoryCodes[missing.subcategory_id].name : ''
    
    // Build the full product name/description
    const parts = []
    
    // 1. COLLECTION NAME (or CATEGORY if no collection)
    if (collectionName) {
        parts.push(collectionName.toUpperCase())
    } else if (categoryName) {
        parts.push(categoryName.toUpperCase())
    }
    
    // 2. COLOR (if available)
    if (colorName) {
        parts.push(colorName.toUpperCase())
    }
    
    // 3. SIZE (if available)
    if (sizeName) {
        parts.push(sizeName.toUpperCase())
    }
    
    // 4. SUB CATEGORY (if available)
    if (subcategoryName) {
        parts.push(subcategoryName.toUpperCase())
    }
    
    // 5. "IN" + MATERIAL (if material available)
    if (materialName) {
        parts.push('IN')
        parts.push(materialName.toUpperCase())
    }
    
    // Join with spaces
    const fullName = parts.join(' ')
    
    // Set BOTH product_name and product_description to the same value
    if (fullName) {
        missing.product_name = fullName
        missing.product_description = fullName
    } else {
        // Fallback if no attributes selected
        const fallback = categoryName ? categoryName.toUpperCase() : 'PRODUCT'
        missing.product_name = fallback
        missing.product_description = fallback
    }
},
            // ================================================================
            // RESIZE / LOCATION HELPERS
            // ================================================================
            
            handleResize() {
                this.isMobile = window.innerWidth < 768
            },
            
            getOrderingLocationNames(orderingLocsub) {
                if (!orderingLocsub) return '';
                const locationIds = orderingLocsub.split('|');
                const locationNames = locationIds.map(id => {
                    const location = this.packet.locsubsdict[id];
                    return location || id;
                });
                return locationNames.join(', ');
            },
            
            onOrderingLocationChange(locationId) {
                this.selectedItems = [];
                this.selectAll = false;
            },
            
            handleShippingLocationChange() {
                const shipToLocation = this.vendorPOForm.shipping_location;
                this.vendorPOForm.receivingLocation = null;
                if (shipToLocation && shipToLocation !== 47) {
                    this.vendorPOForm.receivingLocation = shipToLocation;
                }
            },
            
            getLocationText(locationValue) {
                if (!locationValue) return '';
                if (locationValue === 47) {
                    return 'MECCA WHOLESALE';
                }
                const location = this.packet.locations.find(loc => loc.value === locationValue);
                return location ? location.text : '';
            },
            
            handleBillingLocationChange() {
                // Bill to is independent
            },
            
            onshippingLocationChange(newLocation) {
                if (newLocation) {
                    this.handleShippingLocationChange();
                }
            },
            
            getProfitClass(item) {
                if (!item.selling_price || !item.landed_cost) return "";
                const selling = Number(item.selling_price);
                const cost = Number(item.landed_cost);
                const minSelling = cost * 1.6;
                return selling >= minSelling ? "bg-green" : "bg-red";
            },
            
            formatDate(dateStr) {
                if (!dateStr) return "";
                let dateObj;
                if (dateStr.includes('GMT')) {
                    dateObj = new Date(dateStr);
                } else {
                    dateObj = new Date(dateStr);
                }
                const day = String(dateObj.getDate()).padStart(2, "0");
                const month = String(dateObj.getMonth() + 1).padStart(2, "0");
                const year = dateObj.getFullYear();
                return `${day}-${month}-${year}`;
            },
            
            formatNumber(value) {
                if (!value && value !== 0) return '0.00';
                return parseFloat(value).toFixed(2);
            },

            // ================================================================
            // PO NUMBER GENERATION
            // ================================================================
            
            fetchPONumbers(vendorId) {
                if (!vendorId) {
                    this.vendorPOForm.poNumber = '';
                    return;
                }

                var that = this;
                var payload = {
                    vendor_id: vendorId
                };

                Requestor.postSyncP(
                    "/api/customer_backorder/get_vendor_po_numbers/",
                    payload,
                    this,
                    function(response) {
                        if (response.data && response.data.success) {
                            if (Array.isArray(response.data.po_numbers)) {
                                that.generateNextPONumber(response.data.po_numbers);
                            } else {
                                that.vendorPOForm.poNumber = that.generatePONumber();
                            }
                        } else {
                            that.vendorPOForm.poNumber = that.generatePONumber();
                        }
                    },
                    function(error) {
                        console.error("Error fetching PO numbers:", error);
                        that.vendorPOForm.poNumber = that.generatePONumber();
                    }
                );
            },
            
            generateNextPONumber(existingPONumbers) {
                if (!this.selectedVendor || !this.selectedVendor.text) {
                    return;
                }

                var vendorName = this.selectedVendor.text;
                var maxNumber = 1000;

                if (existingPONumbers && existingPONumbers.length > 0) {
                    var numbers = existingPONumbers.map(function(poNumber) {
                        if (typeof poNumber !== 'string') return 0;
                        var match = poNumber.match(/-(\d+)$/);
                        return match ? parseInt(match[1]) : 0;
                    }).filter(function(num) {
                        return !isNaN(num) && num > 0;
                    });

                    if (numbers.length > 0) {
                        maxNumber = Math.max.apply(null, numbers) + 1;
                    }
                }

                this.vendorPOForm.poNumber = vendorName + '-' + maxNumber;
            },
            
            generatePONumber() {
                if (this.selectedVendor && this.selectedVendor.text) {
                    return this.selectedVendor.text + '-1000';
                }
                return '';
            },

            // ================================================================
            // MODAL MANAGEMENT
            // ================================================================
            
            showCreateVendorPOModal() {
                this.modalVisible = true
                
                if (this.selectedVendor && this.selectedVendor.value) {
                    this.fetchPONumbers(this.selectedVendor.value);
                } else {
                    this.vendorPOForm.poNumber = this.generatePONumber();
                }

                const meccaWholesale = this.billing_location_options.find(
                    loc => loc.text === "MECCA WHOLESALE"
                );

                if (meccaWholesale) {
                    this.vendorPOForm.billing_location = meccaWholesale.value;
                }

                this.checkMissingProducts();
                this.$bvModal.show('create-vendor-po-modal');
            },
            
            resetVendorPOForm() {
                this.modalVisible = false
                this.vendorPOForm = {
                    poNumber: '',
                    receivingLocation: null,
                    shipping_location: null,  
                    billing_location: null, 
                    eta: null,
                    status: 1,
                    sendEmail: false,
                    email: ''
                };
                this.isCreatingPO = false;
                this.pdfBlob = null;
                if (this.pdfUrl) {
                    URL.revokeObjectURL(this.pdfUrl);
                    this.pdfUrl = null;
                }
                this.selectedItems = [];
                this.selectAll = false;
                this.missingProducts = [];
                this.skuCounters = {};
            },
            
            onVendorChange(vendorId) {
                this.selectedVendor = vendorId
                    ? this.vendorOptions.find(v => v.value === vendorId)
                    : null;
                this.selectedItems = [];
                this.selectAll = false;

                if (!vendorId) {
                    this.selectedItems = [];
                    this.selectAll = false;
                    this.vendorPOForm.poNumber = '';
                } else if (this.selectedVendor) {
                    this.fetchPONumbers(this.selectedVendor.value);
                }
            },
            
            toggleSelectAll() {
                if (!this.vendor_id) {
                    this.selectAll = false;
                    return;
                }

                if (this.selectAll) {
                    this.selectedItems = this.filtered.filter(item =>
                        item.vendor_id === this.selectedVendor.value && !item.is_in_po
                    );
                } else {
                    this.selectedItems = [];
                }
            },

            // ================================================================
            // MISSING PRODUCT MANAGEMENT
            // ================================================================
            
            checkMissingProducts() {
                this.missingProducts = [];
                this.skuCounters = {};
                
                this.selectedItems.forEach(item => {
                    if (!item.product_exists) {
                        this.missingProducts.push({
                            original_sku: item.product_sku,
                            new_sku: '',
                            product_name: item.product_name || '',
                            product_description: '',
                            collection_name: '',
                            price: item.selling_price || 0,
                            selling_price: item.selling_price || 0,
                            vendor_sku: item.vendor_sku || '',
                            invoice_id: item.invoice_id,
                            invoice_item_id: item.itemid,
                            originalItem: item,
                            saved: false,
                            saving: false,
                            uploading: false,
                            image_url: null,
                            image_file: null,
                            scannedBarcode: '',
                            category_id: null,
                            vendor_id: this.selectedVendor ? this.selectedVendor.value : null,
                            subcategory_id: null,
                            type_id: null,
                            color_id: null,
                            material_id: null,
                            size_id: null,
                            style_id: null,
                            subcategoryOptions: [{ value: null, text: "Select Subcategory" }],
                            typeOptions: [{ value: null, text: "Select Type" }],
                            colorOptions: [{ value: null, text: "Select Color" }],
                            materialOptions: [{ value: null, text: "Select Material" }],
                            sizeOptions: [{ value: null, text: "Select Size" }],
                            styleOptions: [{ value: null, text: "Select Style" }],
                            cubes: 0,
                            quantity_per_box: 1,
                            spiff: 0,
                            height: null,
                            width: null,
                            depth: null,
                            weight: null,
                            assembly_time: null,
                            product_id: null,
                            barcode_image_url: null,
                            _previousCategoryId: null,
                            _skuNumber: null,
                            _skuGenerated: false
                        })
                    }
                })

                if (this.missingProducts.length > 0) {
                    this.$bvToast.toast(
                        `${this.missingProducts.length} product(s) need to be created. Select a category and click the auto-generate button!`,
                        {
                            title: "Products Missing",
                            autoHideDelay: 3000,
                            variant: "danger"
                        }
                    )
                }
            },
            
            isMissingProductValid(missing) {
                return missing.new_sku && 
                       missing.product_name && 
                       missing.price > 0 &&
                       missing.vendor_id !== null &&
                       missing.category_id !== null
            },

            // ================================================================
            // IMAGE UPLOAD
            // ================================================================
            
            uploadMissingProductImage(index) {
                const missing = this.missingProducts[index]
                if (!missing) return
                
                const input = document.createElement('input')
                input.type = 'file'
                input.accept = 'image/*'
                
                input.onchange = async (e) => {
                    const file = e.target.files[0]
                    if (!file) return
                    
                    if (!file.type.startsWith('image/')) {
                        this.$bvToast.toast('Please select an image file', {
                            title: 'Invalid File',
                            variant: 'danger',
                            autoHideDelay: 3000
                        })
                        return
                    }
                    
                    if (file.size > 5 * 1024 * 1024) {
                        this.$bvToast.toast('Image size should be less than 5MB', {
                            title: 'File Too Large',
                            variant: 'danger',
                            autoHideDelay: 3000
                        })
                        return
                    }
                    
                    missing.uploading = true
                    
                    try {
                        const base64 = await this.fileToBase64(file)
                        missing.image_url = base64
                        missing.image_file = file
                        
                        this.$bvToast.toast('Image loaded', {
                            title: 'Success',
                            variant: 'success',
                            autoHideDelay: 2000
                        })
                    } catch (error) {
                        console.error('Upload error:', error)
                        this.$bvToast.toast('Failed to load image', {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 3000
                        })
                    } finally {
                        missing.uploading = false
                    }
                }
                
                input.click()
            },
            
            fileToBase64(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                });
            },
            
            openImagePreview(imageUrl) {
                this.$bvModal.msgBoxOk(`
                    <div class="text-center">
                        <img src="${imageUrl}" style="max-width: 100%; max-height: 80vh;">
                    </div>
                `, {
                    title: 'Product Image',
                    size: 'xl',
                    centered: true,
                    okTitle: 'Close',
                    html: true
                });
            },

            // ================================================================
            // BARCODE SCANNER
            // ================================================================
            
            openScannerForMissingProduct(index) {
                this.currentMissingProductIndex = index
                this.$bvModal.show('modal-product-barcode-scanner')
            },
            
            startProductScanner() {
                if (this.$refs.productQuaggaScanner) {
                    this.$refs.productQuaggaScanner.startScanner()
                }
            },
            
            stopProductScanner() {
                if (this.$refs.productQuaggaScanner) {
                    this.$refs.productQuaggaScanner.stopScanner()
                }
                this.$bvModal.hide('modal-product-barcode-scanner')
                this.currentMissingProductIndex = null
            },
            
            toggleProductCamera() {
                this.productCurrentCamera = this.productCurrentCamera === 'environment' ? 'user' : 'environment'
            },
            
            handleProductBarcodeScan(barcodeValue) {
                if (this.currentMissingProductIndex !== null) {
                    this.lookupBarcodeForMissingProduct(this.currentMissingProductIndex, barcodeValue)
                    this.stopProductScanner()
                }
            },
            
            lookupBarcodeForMissingProduct(index, scannedValue) {
                const missing = this.missingProducts[index]
                if (!missing) return
                
                const barcode = scannedValue || missing.scannedBarcode
                if (!barcode || barcode.trim() === '') {
                    this.$bvToast.toast("Please enter or scan a barcode", {
                        title: "Info",
                        variant: "warning",
                        autoHideDelay: 2000
                    })
                    return
                }
                
                missing.lookingUpBarcode = true
                const barcodeValue = barcode.trim()
                
                const path = "/api/product/search_by_barcode/"
                const data = {
                    barcode: barcodeValue,
                    location_id: null,
                    include_sublocation_breakdown: false,
                    include_damage_info: false
                }
                
                const that = this
                
                const successCallback = function(response) {
                    missing.lookingUpBarcode = false
                    
                    if (response.data.error) {
                        that.$bvToast.toast(response.data.error, {
                            title: "Barcode Not Found",
                            variant: "warning",
                            autoHideDelay: 2000
                        })
                    } else if (response.data.result && response.data.result.length > 0) {
                        const foundProduct = response.data.result[0]
                        
                        if (!missing.saved) {
                            missing.new_sku = foundProduct.product_sku
                            missing.product_name = foundProduct.product_name
                            missing.product_description = foundProduct.product_name
                            missing.price = foundProduct.selling_price
                            missing.selling_price = foundProduct.selling_price
                            missing.cubes = foundProduct.cubes || 0
                            missing.quantity_per_box = foundProduct.quantity_per_box || 1
                            missing.vendor_id = foundProduct.vendor_id || missing.vendor_id
                            missing.category_id = foundProduct.category_id
                            missing.subcategory_id = foundProduct.subcategory_id
                            if (foundProduct.image_url) {
                                missing.image_url = foundProduct.image_url
                            }
                            
                            if (foundProduct.category_id) {
                                that.loadMissingProductCategoryAttributes(index)
                            }
                            
                            that.$bvToast.toast(`Product details loaded from barcode: ${foundProduct.product_sku}`, {
                                title: "Success",
                                variant: "success",
                                autoHideDelay: 2000
                            })
                        }
                    } else {
                        that.$bvModal.msgBoxConfirm(
                            `No product found with barcode: ${barcodeValue}. Would you like to use this as the SKU?`,
                            {
                                title: 'Product Not Found',
                                size: 'sm',
                                buttonSize: 'sm',
                                okVariant: 'primary',
                                okTitle: 'Yes, Use as SKU',
                                cancelTitle: 'Cancel'
                            }
                        ).then(value => {
                            if (value && !missing.saved) {
                                missing.new_sku = barcodeValue
                                that.$bvToast.toast(`SKU set to: ${barcodeValue}`, {
                                    title: "SKU Set",
                                    variant: "info",
                                    autoHideDelay: 2000
                                })
                            }
                        })
                    }
                }
                
                const errorCallback = function(error) {
                    console.error("Barcode lookup error:", error)
                    missing.lookingUpBarcode = false
                    that.$bvToast.toast("Error looking up barcode. Please try again.", {
                        title: "Error",
                        variant: "danger",
                        autoHideDelay: 2000
                    })
                }
                
                Requestor.getSyncP(path, data, this, successCallback, errorCallback)
            },

            // ================================================================
            // SAVE MISSING PRODUCT
            // ================================================================
            
         saveMissingProduct(index) {
    const missing = this.missingProducts[index]
    if (!this.isMissingProductValid(missing)) {
        this.$bvToast.toast("Please fill in SKU, product name, price, vendor, and category", {
            title: "Error",
            autoHideDelay: 3000,
            variant: "danger"
        })
        return
    }

    missing.saving = true

    const properties = {
        quantity_per_box: parseInt(missing.quantity_per_box) || 1,
        low_inventory: false,
        is_parent: false,
        has_child_products: false,
        type: missing.type_id,
        color: missing.color_id,
        size: missing.size_id,
        material: missing.material_id,
        style: missing.style_id,
        vendor_sku: missing.vendor_sku || "",
        height: missing.height ? parseFloat(missing.height) : null,
        width: missing.width ? parseFloat(missing.width) : null,
        depth: missing.depth ? parseFloat(missing.depth) : null,
        weight: missing.weight ? parseFloat(missing.weight) : null,
        assembly_time: missing.assembly_time ? parseInt(missing.assembly_time) : null,
        measurement_unit: 'in',
        invoice_id: missing.invoice_id,
        invoice_item_id: missing.invoice_item_id,
        original_sku: missing.original_sku,
        is_special_order: true,
        merchandise_status: missing.originalItem ? missing.originalItem.merchandise_status : 3
    }

    // Log what we're sending for debugging
    console.log('Saving missing product:', {
        invoice_id: missing.invoice_id,
        invoice_item_id: missing.invoice_item_id,
        new_sku: missing.new_sku,
        category_id: missing.category_id,
        vendor_id: missing.vendor_id,
        product_name: missing.product_name
    })

    const apiItem = {
        product_sku: missing.new_sku.toUpperCase().trim(),
        product_name: missing.product_name.toUpperCase().trim(),
        product_display_name: missing.product_name,
        product_description: missing.product_description || missing.product_name,
        category_id: missing.category_id,
        vendor_id: missing.vendor_id,
        subcategory_id: missing.subcategory_id || null,
        type_id: missing.type_id || null,
        color_id: missing.color_id || null,
        size_id: missing.size_id || null,
        material_id: missing.material_id || null,
        style_id: missing.style_id || null,
        fob_price: parseFloat(missing.price) || 0,
        selling_price: parseFloat(missing.selling_price) || parseFloat(missing.price) || 0,
        wholesale_price: 0,
        special_discount_price: 0,
        cubes: parseFloat(missing.cubes) || 0,
        spiff: parseFloat(missing.spiff) || 0,
        product_type: 1,
        status: "active",
        properties: properties,
        image_url: missing.image_url || null,
        collection_name: missing.collection_name || '',
        // IMPORTANT: These fields are needed to update special_order_items
        invoice_id: missing.invoice_id,
        invoice_item_id: missing.invoice_item_id,
        original_sku: missing.original_sku
    }

    const that = this
    const path = "/api/product/add_batch_products/"
    const data = { items: [apiItem] }

    Requestor.postSyncP(
        path,
        data,
        this,
        function(response) {
            missing.saving = false
            
            if (response.data && response.data.error) {
                that.$bvToast.toast(response.data.error, {
                    title: "Error",
                    autoHideDelay: 3000,
                    variant: "danger"
                })
                return
            }
            
            if (response.data && response.data.result && response.data.result.length > 0) {
                const savedProduct = response.data.result[0]
                missing.saved = true
                missing.product_id = savedProduct.id
                missing.barcode_image_url = savedProduct.barcode_image || null
                
                const originalItem = missing.originalItem
                if (originalItem) {
                    originalItem.product_exists = true
                    originalItem.product_id = savedProduct.id
                    originalItem.product_sku = missing.new_sku
                    originalItem.updated_sku = missing.new_sku
                    
                    const mainItemIndex = that.items.findIndex(item => 
                        item.invoice_id === originalItem.invoice_id && 
                        item.itemid === originalItem.itemid
                    )
                    if (mainItemIndex !== -1) {
                        that.$set(that.items[mainItemIndex], 'product_sku', missing.new_sku)
                        that.$set(that.items[mainItemIndex], 'updated_sku', missing.new_sku)
                        that.$set(that.items[mainItemIndex], 'product_exists', true)
                        that.$set(that.items[mainItemIndex], 'product_id', savedProduct.id)
                    }
                    
                    const selectedIndex = that.selectedItems.findIndex(item => 
                        item.invoice_id === originalItem.invoice_id && 
                        item.itemid === originalItem.itemid
                    )
                    if (selectedIndex !== -1) {
                        that.$set(that.selectedItems[selectedIndex], 'product_sku', missing.new_sku)
                        that.$set(that.selectedItems[selectedIndex], 'updated_sku', missing.new_sku)
                        that.$set(that.selectedItems[selectedIndex], 'product_exists', true)
                        that.$set(that.selectedItems[selectedIndex], 'product_id', savedProduct.id)
                    }
                }
                
                that.$forceUpdate()
                
                that.$bvToast.toast(`Product ${missing.new_sku} created successfully!`, {
                    title: "Success",
                    autoHideDelay: 2500,
                    variant: "success"
                })

                setTimeout(() => {
                    that.missingProducts = that.missingProducts.filter(p => !p.saved)
                    if (that.missingProducts.length === 0) {
                        that.$bvToast.toast("All products created! Ready to create PO.", {
                            title: "Ready",
                            autoHideDelay: 2000,
                            variant: "success"
                        })
                    }
                }, 1500)
            } else {
                that.$bvToast.toast("Failed to create product - no result returned", {
                    title: "Error",
                    autoHideDelay: 3000,
                    variant: "danger"
                })
            }
        },
        function(error) {
            missing.saving = false
            console.error("Error creating product:", error)
            that.$bvToast.toast(error.message || "Failed to create product", {
                title: "Error",
                autoHideDelay: 3000,
                variant: "danger"
            })
        }
    )
},
            
            removeMissingProduct(index) {
                const missing = this.missingProducts[index]
                if (missing.saved) {
                    if (!confirm(`Remove product "${missing.new_sku}"?`)) return
                }
                this.missingProducts.splice(index, 1)
            },

            // ================================================================
            // LOW INVENTORY ALERT
            // ================================================================
            
            showLowInventoryAlertForMissing(index) {
                const missing = this.missingProducts[index]
                if (!missing || !missing.saved || !missing.product_id) {
                    this.$bvToast.toast("Product must be saved first", {
                        title: "Error",
                        variant: "warning",
                        autoHideDelay: 3000
                    })
                    return
                }
                
                this.currentAlertProduct = {
                    product_id: missing.product_id,
                    product_sku: missing.new_sku,
                    product_name: missing.product_name
                }
                this.currentAlertProductIndex = index
                
                this.alertConfig = {
                    alert_type: 'threshold',
                    threshold_quantity: 10,
                    notification_methods: ['email', 'dashboard'],
                    alert_emails: '',
                    notes: '',
                    reminder_frequency: 'weekly'
                }
                
                this.showLowInventoryModal = true
            },
            
            resetLowInventoryModal() {
                this.alertConfig = {
                    alert_type: 'threshold',
                    threshold_quantity: 10,
                    notification_methods: ['email', 'dashboard'],
                    alert_emails: '',
                    notes: '',
                    reminder_frequency: 'weekly'
                }
                setTimeout(() => {
                    if (!this.showLowInventoryModal) {
                        this.currentAlertProduct = null
                        this.currentAlertProductIndex = null
                    }
                }, 300)
            },
            
            saveLowInventoryAlert() {
                if (!this.currentAlertProduct || !this.isAlertConfigValid) {
                    this.$bvToast.toast("Please fill all required fields", {
                        title: "Error",
                        variant: "warning",
                        autoHideDelay: 3000
                    })
                    return
                }
                
                const alertData = {
                    product_id: this.currentAlertProduct.product_id,
                    product_sku: this.currentAlertProduct.product_sku,
                    alert_type: this.alertConfig.alert_type,
                    threshold_quantity: this.alertConfig.threshold_quantity,
                    notification_methods: this.alertConfig.notification_methods,
                    alert_emails: this.alertConfig.alert_emails,
                    notes: this.alertConfig.notes,
                    reminder_frequency: this.alertConfig.reminder_frequency,
                    created_by: this.packet.userDetails.username || 'system'
                }
                
                const path = "/api/product/set_low_inventory_alert/"
                const that = this
                
                const successCallback = function(response) {
                    if (response.data && response.data.error) {
                        that.$bvToast.toast(response.data.error, {
                            title: "Error",
                            variant: "danger",
                            autoHideDelay: 3000
                        })
                    } else {
                        that.$bvToast.toast(`Low inventory alert configured for ${that.currentAlertProduct.product_sku}`, {
                            title: "Alert Set",
                            variant: "success",
                            autoHideDelay: 3000
                        })
                        that.showLowInventoryModal = false
                    }
                }
                
                const errorCallback = function(error) {
                    console.error("Save alert error:", error)
                    that.$bvToast.toast(error.message || "Failed to set low inventory alert", {
                        title: "Error",
                        variant: "danger",
                        autoHideDelay: 3000
                    })
                }
                
                Requestor.postSyncP(path, alertData, this, successCallback, errorCallback)
            },

            // ================================================================
            // PDF GENERATION
            // ================================================================
            
            async generatePDF() {
                const that = this

                if (!this.vendorPOForm.poNumber || !this.vendorPOForm.receivingLocation) {
                    this.$bvToast.toast("Please fill in all required fields", {
                        title: "Error",
                        autoHideDelay: 1500,
                        variant: "danger"
                    })
                    return
                }

                const pdfItems = this.selectedItems.map(item => {
                    const mainItem = this.items.find(i => 
                        i.invoice_id === item.invoice_id && 
                        i.itemid === item.itemid
                    )
                    const sku = (mainItem && mainItem.updated_sku) || item.updated_sku || item.product_sku
                    
                    return {
                        sku: sku,
                        name: item.product_name,
                        customer_name: item.customer_name,
                        invoice_id: item.invoice_id,
                        quantity: item.quantity
                    }
                })

                const pdfData = {
                    po_number: this.vendorPOForm.poNumber,
                    vendor: this.selectedVendor.text,
                    receiving_location: this.receiving_location_options.find(
                        loc => loc.value === this.vendorPOForm.receivingLocation
                    ).text,
                    shipping_location: this.shipping_location_options.find(
                        loc => loc.value === this.vendorPOForm.shipping_location
                    ).text,
                    billing_location: this.billing_location_options.find(
                        loc => loc.value === this.vendorPOForm.billing_location
                    ).text,
                    eta: this.vendorPOForm.eta,
                    status: this.vendor_order_statuses_dict[this.vendorPOForm.status],
                    items: pdfItems,
                    send_email: false,
                    email: ''
                }

                this.items_being_loaded = true

                Requestor.postSyncP(
                    "/api/customer_backorder/generate_pdf/",
                    pdfData,
                    this,
                    function(response) {
                        that.items_being_loaded = false

                        if (response.data && response.data.error) {
                            that.$bvToast.toast(response.data.error, {
                                title: "Error",
                                autoHideDelay: 1500,
                                variant: "danger"
                            })
                            return
                        }

                        try {
                            const blob = new Blob([response.data], { type: "application/pdf" })
                            const pdfUrl = URL.createObjectURL(blob)
                            window.open(pdfUrl, "_blank")
                        } catch (err) {
                            console.error("Error processing PDF blob:", err)
                            that.$bvToast.toast("Failed to display PDF", {
                                title: "Error",
                                autoHideDelay: 1500,
                                variant: "danger"
                            })
                        }
                    },
                    function(error) {
                        that.items_being_loaded = false
                        console.error("PDF generation API error:", error)
                        that.$bvToast.toast("Failed to generate PDF", {
                            title: "Error",
                            autoHideDelay: 1500,
                            variant: "danger"
                        })
                    }
                )
            },

            // ================================================================
            // CREATE VENDOR PO
            // ================================================================
            
            createVendorPO() {
                if (this.isCreatingPO) {
                    this.$bvToast.toast("Purchase order creation already in progress", {
                        title: "Please wait",
                        variant: "warning",
                        autoHideDelay: 1500
                    })
                    return
                }

                if (this.hasUnsavedMissingProducts) {
                    this.$bvToast.toast("Please create all missing products before creating the PO", {
                        title: "Action Required",
                        autoHideDelay: 3000,
                        variant: "warning"
                    })
                    return
                }

                if (!this.vendorPOForm.poNumber || !this.vendorPOForm.receivingLocation || !this.vendorPOForm.shipping_location || !this.vendorPOForm.billing_location) {
                    return
                }
                
                const billingText = this.getLocationText(this.vendorPOForm.billing_location)
                const shipToText = this.getLocationText(this.vendorPOForm.shipping_location)
                const receivingText = this.getLocationText(this.vendorPOForm.receivingLocation)
                
                if (shipToText === 'MECCA WHOLESALE') {
                    const validLocations = ['9TH ST ', '101 WH', 'FOLCROFT']
                    if (!validLocations.some(loc => receivingText.includes(loc))) {
                        this.$bvToast.toast("For Mecca Wholesale shipping, receiving location must be 9th ST, 101 WH, or FOLCROFT.", {
                            title: "Validation Error",
                            autoHideDelay: 3000,
                            variant: "warning"
                        })
                        return
                    }
                } else {
                    if (shipToText !== receivingText) {
                        this.$bvToast.toast("For store locations, receiving location must match the shipping location.", {
                            title: "Validation Error",
                            autoHideDelay: 3000,
                            variant: "warning"
                        })
                        return
                    }
                }

                if (this.vendorPOForm.sendEmail) {
                    if (!this.vendorPOForm.email) {
                        this.$bvToast.toast("Please enter a valid email address", {
                            title: "Error",
                            autoHideDelay: 1500,
                            variant: "danger"
                        })
                        return
                    }

                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                    if (!emailRegex.test(this.vendorPOForm.email)) {
                        this.$bvToast.toast("Please enter a valid email address format", {
                            title: "Error",
                            autoHideDelay: 1500,
                            variant: "danger"
                        })
                        return
                    }
                }

                this.isCreatingPO = true

                const payloadItems = this.selectedItems.map(item => {
                    const mainItem = this.items.find(i => 
                        i.invoice_id === item.invoice_id && 
                        i.itemid === item.itemid
                    )
                    
                    const sku = (mainItem && mainItem.updated_sku) || item.updated_sku || item.product_sku
                    
                    return {
                        product_sku: sku,
                        product_name: item.product_name,
                        invoice_id: item.invoice_id,
                        customer_name: item.customer_name,
                        quantity_ordered: item.quantity,
                        invoice_item_id: item.itemid,
                        locsub: null,
                        notes: item.notes || '',
                        product_exists: item.product_exists || false,
                        merchandise_status: item.merchandise_status || 2,
                        is_special: item.is_special || false
                    }
                })

                const payload = {
                    po_number: this.vendorPOForm.poNumber,
                    vendor_id: this.selectedVendor.value,
                    vendor_name: this.selectedVendor.text,
                    receiving_location_id: this.vendorPOForm.receivingLocation,
                    shipping_location: this.vendorPOForm.shipping_location,
                    shipping_location_name: this.shipping_location_options.find(
                        loc => loc.value === this.vendorPOForm.shipping_location
                    ),
                    billing_location_name: this.billing_location_options.find(
                        loc => loc.value === this.vendorPOForm.billing_location
                    ).text,
                    billing_location: this.vendorPOForm.billing_location,
                    status: this.vendor_order_statuses_dict[this.vendorPOForm.status],
                    receiving_location_name: this.receiving_location_options.find(
                        loc => loc.value === this.vendorPOForm.receivingLocation
                    ).text,
                    eta: this.vendorPOForm.eta
                        ? moment(this.vendorPOForm.eta, 'MM-DD-YYYY').format('YYYY-MM-DD')
                        : null,
                    created_by: JSON.parse(localStorage.userDetails).username,
                    send_email: this.vendorPOForm.sendEmail,
                    email: this.vendorPOForm.sendEmail ? this.vendorPOForm.email : '',
                    items: payloadItems
                }

                const that = this
                const path = "/api/customer_backorder/create_backorder_po/"

                this.items_being_loaded = true

                Requestor.postSyncP(
                    path,
                    payload,
                    this,
                    function(response) {
                        that.items_being_loaded = false
                        that.isCreatingPO = false
                        
                        if (response.data.error) {
                            that.$bvToast.toast(response.data.error, {
                                title: "Error",
                                autoHideDelay: 3000,
                                variant: "danger"
                            })
                        } else {
                            let successMessage = "PO created successfully!"

                            if (that.vendorPOForm.sendEmail) {
                                successMessage += ` Email sent to ${that.vendorPOForm.email}`
                            }

                            that.$bvToast.toast(successMessage, {
                                title: "Success",
                                autoHideDelay: 2000,
                                variant: "success"
                            })
                            that.$bvModal.hide('create-vendor-po-modal')
                            that.resetVendorPOForm()

                            that.selectedItems = []
                            that.selectAll = false
                            that.missingProducts = []

                            that.fetch_customer_vendor_orders()
                        }
                    },
                    function(error) {
                        that.items_being_loaded = false
                        that.isCreatingPO = false
                        console.error("API Error:", error)
                        that.$bvToast.toast(error.message || "Failed to create PO", {
                            title: "Error",
                            autoHideDelay: 3000,
                            variant: "danger"
                        })
                    }
                )
            },

            // ================================================================
            // FETCH CUSTOMER VENDOR ORDERS
            // ================================================================
            
            fetch_customer_vendor_orders() {
                let payload = {
                    status: this.status,
                    userRole: this.user_is_admin ? "admin" : "user"
                }

                if (!this.user_is_admin && this.user_location_id) {
                    payload.location_id = this.user_location_id
                }

                let that = this
                let path = "/api/sales/get_customer_vendor_orders/"
                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result.map(item => ({
                            ...item,
                            edit: false,
                            vendor_order_status: !item.is_in_po ? 1 : item.vendor_order_status,
                            product_exists: item.product_exists !== undefined ? item.product_exists : true,
                            updated_sku: null,
                            merchandise_status: item.merchandise_status || 2
                        }))

                        that.selectedItems = []
                        that.selectAll = false

                        const vendorsWithItems = [...new Set(that.items.map(item => item.vendor_id))]
                        that.vendorOptions = that.packet.vendors.filter(vendor =>
                            vendorsWithItems.includes(vendor.value) || vendor.value === null
                        )
                        that.vendorOptions.unshift({value: null, text: "ALL"})
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        )
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    )
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true
                Requestor.postAsyncP(path, payload, this, s, f)
            },
        },
        watch: {
            selectedItems: {
                handler(newVal) {
                    if (!this.vendor_id) {
                        this.selectAll = false
                        return
                    }

                    if (this.filtered.length > 0 && this.selectedVendor) {
                        const vendorItems = this.filtered.filter(item =>
                            item.vendor_id === this.selectedVendor.value && !item.is_in_po
                        )
                        this.selectAll = newVal.length === vendorItems.length
                    } else {
                        this.selectAll = false
                    }
                    
                    if (this.modalVisible) {
                        this.checkMissingProducts()
                    }
                },
                deep: true
            },
            ordering_location(newVal) {
                if (newVal) {
                    this.selectedItems = []
                    this.selectAll = false
                }
            },
            'vendorPOForm.shipping_location': function(newVal) {
                if (newVal) {
                    this.handleShippingLocationChange()
                }
            },
            'vendorPOForm.billing_location': function(newVal) {
                // Bill to is independent
            },
            vendor_id(newVal) {
                if (!newVal) {
                    this.selectedItems = []
                    this.selectAll = false
                }
            },
            po_status_filter(newVal) {
                if (newVal === "with_po") {
                    this.selectedItems = []
                    this.selectAll = false
                }
            }
        },
        created: function() {
            this.packet = JSON.parse(localStorage.packet)
            this.packet.userDetails = JSON.parse(localStorage.userDetails)

            this.loadVendors()

            if (this.packet.locations) {
                this.packet.locations = this.packet.locations.map(loc => {
                    if (loc.text === '9TH ST , 101 wH, FOLCROFT') {
                        return {...loc, text: 'MECCA WHOLESALE'}
                    }
                    return loc
                })
            }

            const userDetails = JSON.parse(localStorage.userDetails)
            this.user_is_admin = userDetails.userrole === "admin" || false

            if (userDetails.properties && userDetails.properties.location_id){
                this.user_location_id = parseInt(userDetails.properties.location_id)
            }

            this.loadAllCategoryData()
            this.fetch_customer_vendor_orders()
        }
    }
</script>

<style scoped>
.bg-red {
  background-color: #ff4d4d !important;
  color: #fff !important;
}
.bg-green {
  background-color:#ADD8E6 !important;
  color: #000 !important;
}

.diver {
  overflow: auto;
  width: 100%;
  height: 600px;
  position: relative; 
}
td, th {
  border: 1px solid;
  width: 300px;
}
th { background-color: white; }

table {
  table-layout: fixed;
  width: 100%;
  border-collapse: separate; 
  border-spacing: 0;
}
td:first-child, th:first-child {
  position: sticky;
  left: 0;
  z-index: 1;
  background-color: white;
  border: 1px solid black;
}
td:last-child, th:last-child {
  position: sticky;
  right: 0;
  z-index: 1;
  background-color: white;
  width: 150px;
  border: 1px solid black;
}
thead tr th {
  position: sticky;
  top: 0;
}
th:first-child, th:last-child {
  z-index: 2;
  background-color: white;
  border: 1px solid black;
}

.srr {
  font-size: 11px;
  text-align: center;
  background: #efefef;
  border: 1px solid #010101;
}
.srrv {
  font-size: 13px;
  text-align: center;
  background: white;
  border: 1px solid #010101;
  padding: 5px;
}

.invoice-link {
  background: lightblue;
  text-decoration: none;
  cursor: pointer;
}
.invoice-link:hover {
  text-decoration: none;
  font-size: 14px;
}

.modal-xl {
  min-width: 1000px !important;
}
.custom-email-width {
  width: 270px !important;
  max-width: 100%;
}

.missing-product-card {
  background: #fff8f8;
  border: 1px solid #dc3545;
  border-radius: 12px;
  transition: all 0.3s ease;
}
.missing-product-card:hover {
  box-shadow: 0 4px 16px rgba(220, 53, 69, 0.15);
}
.missing-product-card .form-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #495057;
  margin-bottom: 4px;
}
.missing-product-card .form-label.required:after {
  content: " *";
  color: #dc3545;
}

.product-image-preview {
  position: relative;
  flex-shrink: 0;
}
.product-image-preview .img-thumbnail {
  cursor: pointer;
  transition: transform 0.2s;
}
.product-image-preview .img-thumbnail:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}
.image-placeholder {
  cursor: pointer;
  transition: all 0.2s;
}
.image-placeholder:hover {
  background: #e9ecef !important;
  transform: scale(1.02);
}
.top-0 { top: 0; }
.right-0 { right: 0; }

.barcode-scanner-section {
  background: #f8f9fa;
  border-color: #dee2e6 !important;
}

.selected-item {
  padding: 8px 12px;
}
.selected-item:last-child {
  border-bottom: none !important;
}
.selected-items-container {
  max-height: 200px;
  overflow-y: auto;
}

.low-inventory-form {
  padding: 10px;
}
.low-inventory-form .form-label {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
}
.low-inventory-form .form-label.required:after {
  content: " *";
  color: #dc3545;
}

.badge-counter {
  display: inline-block;
  min-width: 24px;
  height: 24px;
  background: #667eea;
  color: white;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  padding: 0 8px;
  margin-left: 8px;
}

@media (max-width: 768px) {
  td:first-child,
  th:first-child,
  td:last-child,
  th:last-child,
  td:nth-child(2),
  th:nth-child(2),
  thead tr th {
    position: static !important;
    left: auto !important;
    right: auto !important;
    top: auto !important;
    z-index: auto !important;
  }
  .diver {
    height: auto;
    overflow-x: auto;
    overflow-y: auto;
  }
  .modal-xl {
    min-width: 100% !important;
  }
  .missing-product-card .row > div {
    margin-bottom: 10px;
  }
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.missing-product-card {
  animation: fadeSlideIn 0.3s ease;
}
@keyframes fadeSlideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.is-invalid {
  border-color: #dc3545 !important;
}
.is-invalid:focus {
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1) !important;
}
.is-valid {
  border-color: #28a745 !important;
}
.is-valid:focus {
  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.1) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/VendorOrders/ListCustomerOrders.vue